webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	__webpack_require__(335);
	
	__webpack_require__(417);
	
	__webpack_require__(418);
	
	__webpack_require__(422);
	
	__webpack_require__(429);
	
	__webpack_require__(437);
	
	__webpack_require__(474);
	
	var _components = __webpack_require__(518);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _filters = __webpack_require__(803);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _services = __webpack_require__(805);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _directives = __webpack_require__(811);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	__webpack_require__(815);
	
	var _appTemplate = __webpack_require__(817);
	
	var _appTemplate2 = _interopRequireDefault(_appTemplate);
	
	var _app = __webpack_require__(818);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _faviconCooper = __webpack_require__(820);
	
	var _faviconCooper2 = _interopRequireDefault(_faviconCooper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*var history_api = typeof history.pushState !== 'undefined';
	if ( history_api ) history.pushState(null, '', 'senhaop/#/');*/
	
	/**
	 * Main App Component
	 * Register base component to bootstrap entire app
	 */
	_angular2.default.module('app', [_angularjs2.default, _filters2.default, _services2.default, _components2.default, _directives2.default]).config(["$locationProvider", "$urlRouterProvider", "$stateProvider", function ($locationProvider, $urlRouterProvider, $stateProvider) {
		"ngInject";
		// @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions#how-to-configure-your-server-to-work-with-html5mode
	
		$locationProvider.html5Mode(false).hashPrefix('');
	}]).component('app', {
		template: _appTemplate2.default,
		controller: _app2.default
	});

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(438);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * PLUGINS, EXTENSIONS AND UTILS
	 * @AUTHOR RODRIGO
	 */
	
	(function () {
		console.log("Applying extensions.js");
	
		// --- JQUERY PLUGINS
	
		/**
	  *  Plugin that makes the screen scroll particular component visible on the screen.
	  *
	  *  Usage: Ex1: $("#elementId").scrollTo();
	  */
		if (window.$) window.$.fn.scrollTo = function () {
			var isVisibleOnScreen = function isVisibleOnScreen(elem) {
				var docViewTop = window.$(window).scrollTop();
				var docViewBottom = docViewTop + window.$(window).height();
				var elemTop = window.$(elem).offset().top;
				var elemBottom = elemTop + window.$(elem).height();
	
				return elemBottom <= docViewBottom && elemTop >= docViewTop;
			};
	
			if (!isVisibleOnScreen(this)) {
				window.$('html, body').animate({
					scrollTop: window.$(this).offset().top + 'px'
				}, 'fast');
				return this; // for chaining...
			}
		};
	
		/**
	  *  Plugin that makes the screen scroll to top of screen.
	  *
	  *  Usage: Ex1: $("#top").scrollTo();
	  */
		if (window.$) window.$.fn.scrollToTop = function () {
			window.$('html, body').animate({
				scrollTop: 0
			}, 'fast');
			return false;
		};
	
		/**
	  *  Plugin to check if any element has scrollbar
	  *  Usage: Ex1: $("#elementId").hasScrollBar();
	  */
		if (window.$) window.$.fn.hasScrollBar = function () {
			return this.get(0).scrollHeight > this.get(0).clientHeight;
		};
	
		/**
	  * Check if current element collides with another on the screen
	  * @param targetElement
	  * @returns boolean if two elements colides, false if don't.
	  */
		if (window.$) window.$.fn.collidesWith = function (targetElement) {
			var getPositions = function getPositions(elem) {
				var pos = void 0,
				    width = void 0,
				    height = void 0;
				pos = window.$(elem).position();
				width = window.$(elem).width();
				height = window.$(elem).height();
	
				return [[pos.left, pos.left + width], [pos.top, pos.top + height]];
			};
	
			var comparePositions = function comparePositions(p1, p2) {
				var r1 = void 0,
				    r2 = void 0;
				r1 = p1[0] < p2[0] ? p1 : p2;
				r2 = p1[0] < p2[0] ? p2 : p1;
	
				return r1[1] > r2[0] || r1[0] === r2[0];
			};
	
			if (!targetElement || !targetElement.get(0) || !this.get(0)) {
				console.warn("JQuery collidesWith: currentElement and/or targetElement are null");
				return false;
			}
	
			var pos1 = getPositions(this),
			    pos2 = getPositions(targetElement);
	
			return comparePositions(pos1[0], pos2[0]) && comparePositions(pos1[1], pos2[1]);
		};
	
		// --- NUMBER EXTENSIONS
	
		/**
	  * Plugin for formatting numbers
	  * Number.prototype.format(n, x, s, c)
	  *
	  * @param n: Decimal size, eg: 2
	  * @param x: Thousands or blocks size, eg: 3
	  * @param s: Delimiters of the thousands or blocks, eg: '.'
	  * @param c: Decimal delimiter, eg: ','
	  *
	  * Usage: Ex1: new Number(10000).format(2, 3, '.', ',');
	  *        Ex2: parseFloat(10000).format(2, 3, '.', ',');
	  *        Ex3: parseInt(10000).format(2, 3, '.', ',');
	  *
	  * @see Another approach is String.mask
	  */
		if (!Number.prototype.format) Object.defineProperty(Number.prototype, "format", {
			value: function value() {
				var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
				var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
				var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
				var c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ',';
	
				var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
				var num = this.toFixed(Math.max(0, ~~n));
				return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
			}
		});
	
		/**
	  * Plugin for formatting Brazilian Real numbers
	  *
	  * @param signed: Boolean true or false. If true or undefined, return que output number with 'R$' sign,
	  * if false, returns formatted number only.
	  *
	  * Usage: Ex1: new Number(10000).formatAsBRL();
	  *        Ex2: 10000.32.formatAsBRL();
	  */
		if (!Number.prototype.formatAsBRL) Object.defineProperty(Number.prototype, "formatAsBRL", {
			value: function value() {
				var signed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
				return '' + (signed ? "R$ " : '') + this.format();
			}
		});
	
		// --- STRING EXTENSIONS
	
		/**
	  * Plugin to extract numbers of Strings, returns a String containing only numbers and other escaped characters.
	  * @param s: Chars to scape, ex: -.,, _-, , -, _-
	  *
	  * Usage: Ex1: "ABC123D-F*G".onlyNumbers();
	  * Usage: Ex2: "ABC123D-F*G".onlyNumbers("D");
	  * Usage: Ex3: "ABC123D-F*G".onlyNumbers("FG");
	  * Usage: Ex4: "ABC123D-F*G".onlyNumbers("FG*-");
	  * Usage: Ex5: "ABC123D-F*G".onlyNumbers("*-");
	  */
		if (!String.prototype.onlyNumbers) Object.defineProperty(String.prototype, "onlyNumbers", {
			value: function value(s) {
				var patternBase = "[^0-9{*}]";
	
				if (s) patternBase = patternBase.replace("{*}", s);else patternBase = patternBase.replace("{*}", "");
	
				return this.replace(new RegExp(patternBase, "g"), "");
			}
		});
	
		/**
	  * Plugin to extract Alpha chars of Strings, returns a String containing only Alpha and other escaped characters.
	  * @param s: Chars to scape, ex: -.,, _-, , -, _-
	  *
	  * Usage: Ex1: "ABC123D-F*G".onlyAlpha();
	  * Usage: Ex2: "ABC123D-F*G".onlyAlpha("1");
	  * Usage: Ex3: "ABC123D-F*G".onlyAlpha("23");
	  * Usage: Ex4: "ABC123D-F*G".onlyAlpha("-");
	  * Usage: Ex5: "ABC123D-F*G".onlyAlpha("*-");
	  */
		if (!String.prototype.onlyAlpha) Object.defineProperty(String.prototype, "onlyAlpha", {
			value: function value(s) {
				var patternBase = "[^A-Za-z{*}]";
	
				if (s) patternBase = patternBase.replace("{*}", s);else patternBase = patternBase.replace("{*}", "");
	
				return this.replace(new RegExp(patternBase, "g"), "");
			}
		});
	
		/**
	  * Plugin to extract Alphanumeric chars of Strings, returns a String containing only Alphanumeric and other escaped characters.
	  * @param s: Chars to scape, ex: -.,, _-, , -, _-
	  *
	  * Usage: Ex1: "ABC123D-F*G".onlyAlphanumeric(); //ABC123DFG
	  * Usage: Ex2: "ABC123D-F*G".onlyAlphanumeric("*"); //ABC123DF*G
	  */
		if (!String.prototype.onlyAlphanumeric) Object.defineProperty(String.prototype, "onlyAlphanumeric", {
			value: function value() {
				var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
				return this.replace(new RegExp('[^A-Za-z0-9' + s + ']', "g"), "");
			}
		});
	
		/**
	  * Same of Alphanumeric, but don't allow number as first char of a String
	  * @param s: Chars to scape, ex: -.,, _-, , -, _-
	  *
	  * Usage: Ex1: "098ABC123D-F*G".onlyAlphanumeric(); //ABC123DFG
	  * Usage: Ex2: "7-65ABC123D-F*G".onlyAlphanumeric("*-"); //-ABC123DF*G
	  */
		if (!String.prototype.onlyAlphanumericUnderscoreAlphaFirst) Object.defineProperty(String.prototype, "onlyAlphanumericUnderscoreAlphaFirst", {
			value: function value() {
				return this.replace(new RegExp('^[^a-zA-Z_$]*|[^A-Za-z0-9_$]', "g"), "");
			}
		});
	
		/**
	  * Cast first char of a String in uppercase
	  *
	  * Usage: Ex1: "oi mesquitao tao tao".capitalize(); //Oi mesquitao tao tao
	  */
		if (!String.prototype.capitalize) Object.defineProperty(String.prototype, "capitalize", {
			value: function value() {
				return this.charAt(0).toUpperCase() + this.slice(1);
			}
		});
	
		/**
	  * Plugin to convert a formatted Brazilian Real String to float.
	  *
	  * Usage: Ex1: "R$ 100,10".brazilianRealToFloat();
	  */
		if (!String.prototype.brazilianRealToFloat) Object.defineProperty(String.prototype, "brazilianRealToFloat", {
			value: function value() {
				var val = parseFloat(this.onlyNumbers(",").replace(",", "."));
				return isNaN(val) ? 0 : val;
			}
		});
	
		/**
	  * Utility method to check if a String is a valid email.
	  *
	  * Usage: Ex1: "rodrigo@ae.com".isEmail();
	  */
		if (!String.prototype.isEmail) Object.defineProperty(String.prototype, "isEmail", {
			value: function value() {
				var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return pattern.test(this);
			}
		});
	
		/**
	  * Utility method to check if a String is a valid URL.
	  *
	  * Usage: Ex1: "http://test.com.br".isURL();
	  */
		if (!String.prototype.isURL) Object.defineProperty(String.prototype, "isURL", {
			value: function value() {
				var pattern = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
				return pattern.test(this);
			}
		});
	
		/**
	  * Utility method to check if a String is a valid CPF.
	  *
	  * Usage: Ex1: "02687403130".isEmail();
	  */
		if (!String.prototype.isCPF) Object.defineProperty(String.prototype, "isCPF", {
			value: function value() {
				var numbers = void 0,
				    digits = void 0,
				    sum = void 0,
				    i = void 0,
				    result = void 0,
				    equalDigits = 1;
				if (this.length < 11) return false;
				for (i = 0; i < this.length - 1; i++) {
					if (this.charAt(i) !== this.charAt(i + 1)) {
						equalDigits = 0;
						break;
					}
				}if (!equalDigits) {
					numbers = this.substring(0, 9);
					digits = this.substring(9);
					sum = 0;
					for (i = 10; i > 1; i--) {
						sum += numbers.charAt(10 - i) * i;
					}result = sum % 11 < 2 ? 0 : 11 - sum % 11;
					if (result !== digits.charAt(0)) return false;
					numbers = this.substring(0, 10);
					sum = 0;
					for (i = 11; i > 1; i--) {
						sum += numbers.charAt(11 - i) * i;
					}result = sum % 11 < 2 ? 0 : 11 - sum % 11;
	
					return result === digits.charAt(1);
				} else {
					return false;
				}
			}
		});
	
		/**
	  * Utility method to check if a String is a valid CNPJ.
	  */
		if (!String.prototype.isCNPJ) Object.defineProperty(String.prototype, "isCNPJ", {
			value: function value() {
				var numbers = void 0,
				    digits = void 0,
				    sum = void 0,
				    i = void 0,
				    result = void 0,
				    position = void 0,
				    size = void 0,
				    equalDigits = 1;
				if (this.length < 14 && this.length < 15) return false;
				for (i = 0; i < this.length - 1; i++) {
					if (this.charAt(i) !== this.charAt(i + 1)) {
						equalDigits = 0;
						break;
					}
				}if (!equalDigits) {
					size = this.length - 2;
					numbers = this.substring(0, size);
					digits = this.substring(size);
					sum = 0;
					position = size - 7;
					for (i = size; i >= 1; i--) {
						sum += numbers.charAt(size - i) * position--;
						if (position < 2) position = 9;
					}
					result = sum % 11 < 2 ? 0 : 11 - sum % 11;
					if (result !== digits.charAt(0)) return false;
					size += 1;
					numbers = this.substring(0, size);
					sum = 0;
					position = size - 7;
					for (i = size; i >= 1; i--) {
						sum += numbers.charAt(size - i) * position--;
						if (position < 2) position = 9;
					}
					result = sum % 11 < 2 ? 0 : 11 - sum % 11;
	
					return result === digits.charAt(1);
				} else return false;
			}
		});
	
		/**
	  * Plugin to count the number of characters present in a current string
	  * @param c: Character to be counted, ex: -.,, _-, , -, _-
	  *
	  * Usage: Ex1: "ABCCD".count("C"); //2
	  */
		if (!String.prototype.count) Object.defineProperty(String.prototype, "count", {
			value: function value(c) {
				if (c) {
					var size = this.match(new RegExp(c, 'g'));
					return size && size !== null ? size.length : 0;
				}
	
				return 0;
			}
		});
	
		/**
	  * Plugin to check if a given String contains given value.
	  * @param c: Character to be searched into String, ex: -.,, _-, , -, _-, AA, B, etc.
	  *
	  * Usage: Ex1: "aew".contains('a'); //true
	  */
		if (!String.prototype.contains) Object.defineProperty(String.prototype, "contains", {
			value: function value(c) {
				return c !== undefined && (c + "").length > 0 ? this.indexOf(c + "") !== -1 : false;
			}
		});
	
		/**
	  * Define a function to replace all chars to an string.
	  *
	  * @param from: String to be replaced.
	  * @param to: String to replace.
	  *
	  * Usage: Ex1: "RODRIGO".replaceAll('O', 'E'); //REDRIGE
	  */
		if (!String.prototype.replaceAll) Object.defineProperty(String.prototype, "replaceAll", {
			value: function value(from, to) {
				var escapeRegExp = function escapeRegExp(string) {
					return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
				};
	
				return this.replace(new RegExp(escapeRegExp(from), 'g'), to);
			}
		});
	
		/**
	  * Define a function to replace tokens of a given JSON object.
	  * For each JSON key try to find corresponding token on base string and replace with JSON[key] value
	  *
	  * @param json: JSON tokens to replace base string.
	  * @param defaultDelimiterActive: If true, default REACT ROUTER delimiter will be used in conjuction with json key
	  *
	  * Usage: Ex1: "/path/:idPath".replaceTokens({idPath: "aew"}); ///path/aew
	  *        Ex2: "/path/:idPath".replaceTokens({idPath: "aew"}, false); ///path/:aew
	  *        Ex3: "aew rodrigo aew".replaceTokens({rodrigo: "aewww"}); ///aew rodrigo aew
	  *        Ex4: "aew rodrigo aew".replaceTokens({rodrigo: "aewww"}, false); ///aew aewww aew
	  */
		if (!String.prototype.replaceTokens) Object.defineProperty(String.prototype, "replaceTokens", {
			value: function value(json) {
				var defaultDelimiterActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (!json || (0, _keys2.default)(json).length === 0) return this;
	
				var str = this;
	
				for (var key in json) {
					if (json.hasOwnProperty(key)) str = str.replace((defaultDelimiterActive ? ":" : "") + key, json[key]);
				}return str;
			}
		});
	
		/**
	  * Replace a char in specific index
	  * @param index
	  * @param character
	  * @returns {string}
	  */
		if (!String.prototype.replaceAt) Object.defineProperty(String.prototype, "replaceAt", {
			value: function value(index, character) {
				return this.substr(0, index) + character + this.substr(index + character.length);
			}
		});
	
		/**
	  * Reverse the String
	  *
	  * Usage: Ex1: "RODRIGO".reverse();
	  */
		if (!String.prototype.reverse) Object.defineProperty(String.prototype, "reverse", {
			value: function value() {
				return this.split("").reverse().join("");
			}
		});
	
		/**
	  * Crop to
	  *
	  * Usage: Ex1: "RODRIGO".reverse();
	  */
		if (!String.prototype.cropToLength) Object.defineProperty(String.prototype, "cropToLength", {
			value: function value() {
				var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
				var addReticence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var suffix = addReticence ? '...' : '';
	
				if (limit > this.length) return this;
	
				return this.substring(0, limit) + suffix;
			}
		});
	
		/**
	  * Unmask a String value leaving only Alphanumeric chars.
	  *
	  * Usage: Ex1: '026.874.031-30'.unmask(); //02687403130
	  */
		if (!String.prototype.unmask) Object.defineProperty(String.prototype, "unmask", {
			value: function value() {
				var exp = /[^A-Za-z0-9]/g;
				return this.replace(exp, "");
			}
		});
	
		/***
	  * Generic fixed size mask formatter.
	  *
	  * @param mask: The mask to be applied on current value
	  * @param fillReverse: Boolean value. If true, applies the mask from right to left, if false or undefined,
	  * applies from left to right.
	  *
	  * Usage: Ex1: '02687403130'.mask('000.000.000-00'); //026.874.031-30
	  *        Ex2: '02687403130'.mask('000.000.000-00', true); //026.874.031-30
	  *        Ex3: '0268'.mask('000.000.000-00'); //026.8
	  *        Ex4: '0268740'.mask('000.000.000-00'); //026.874.0
	  *        Ex5: '0268'.mask('000.000.000-00', true); //02-68
	  *        Ex6: '026874031'.mask('000.000.000-00', true); //0.268.740-31
	  *
	  * @see Another approach is Number.format for dynamic size numbers, money, etc.
	  *
	  */
		if (!String.prototype.mask) Object.defineProperty(String.prototype, "mask", {
			value: function value(mask, fillReverse) {
				var value = fillReverse === true ? this.unmask().reverse() : this.unmask();
				var maskArray = fillReverse === true ? mask.split('').reverse() : mask.split('');
	
				var delimiters = ['(', ')', '{', '}', '[', ']', '"', '\'', '<', '>', '/', '*', '\\', '%', '?', ';', ':', '&', '$', '#', '@', '!', '-', '_', '+', '=', '~', '`', '^', '.', ','];
	
				maskArray.forEach(function (e, idx) {
					if (delimiters.contains(e) && value.slice(idx) !== '') value = [value.slice(0, idx), e, value.slice(idx)].join('');
				});
	
				return fillReverse === true ? value.reverse() : value;
			}
		});
	
		/***
	  * Return the first char from the current string
	  *
	  * @param uppercase: If true, return char as uppercase, otherwise, returns lowercase
	  */
		if (!String.prototype.firstChar) Object.defineProperty(String.prototype, "firstChar", {
			value: function value() {
				var uppercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				var value = this.substring(0, 1);
	
				return uppercase ? value.toUpperCase() : value.toLowerCase();
			}
		});
	
		// --- ARRAYS EXTENSIONS
	
		/**
	  * Plugin to check if a Arrays contains given value.
	  * @param c: Character to be searched into String, ex: -.,, _-, , -, _-, AA, B, etc.
	  *
	  * Usage: Ex1: "aew".contains('a');
	  */
		if (!Array.prototype.contains) Object.defineProperty(Array.prototype, "contains", {
			value: function value(c) {
				return c !== undefined ? this.indexOf(c) !== -1 : false;
			}
		});
	})();

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(475);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(479);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(485);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(438);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate a UUID
	 * @param withSeparator bolean
	 * @returns {string}
	 */
	function uuid() {
		var withSeparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
		var sep = withSeparator ? '-' : '';
		var uuid = '';
	
		for (var i = 0; i < 8; i++) {
			uuid += Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1) + sep;
		}return uuid;
	}
	
	/**
	 * Generate a half size UUID
	 * @param withSeparator bolean
	 * @returns {string}
	 */
	function halfUuid(withSeparator) {
		var uuid = this.uuid(withSeparator);
		return uuid.substring(0, uuid.length / 2);
	}
	
	/**
	 * Resolve the current Browser Language
	 */
	function resolveBrowserLanguage() {
		return (navigator.language || navigator.userLanguage).toLocaleLowerCase();
	}
	
	/**
	 * Encode object json to url parameters
	 *
	 * @param      {Object} json The object needs to encode as url parameters;
	 * @param      {Object} complete If string must be returned with "?", complete should be true;
	 */
	function jsonToQueryString() {
		var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		var str = '';
		for (var key in json) {
			if (!isEmpty(json[key]) && !isEmpty(str)) str += '&';
	
			if (!isEmpty(json[key])) str += key + '=' + encodeURIComponent(json[key]);
		}
	
		if (complete && str.length > 0) str = "?" + str;
	
		return str;
	}
	
	/**
	 * Open popup
	 * @param url
	 * @param title
	 * @param w width
	 * @param h height
	 * @param cb Callback before popup close
	 */
	function popupCenter(url, title, w, h, cb) {
		var dualScreenLeft = window.screenLeft ? window.screenLeft : window.screen.left;
		var dualScreenTop = window.screenTop ? window.screenTop : window.screen.top;
	
		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
	
		var left = width / 2 - w / 2 + dualScreenLeft;
		var top = height / 2 - h / 2 + dualScreenTop;
		var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	
		// Puts focus on the newWindow
		if (window.focus) {
			newWindow.focus();
		}
		newWindow.opener.closeCallback = cb;
		newWindow.opener.errorCallback = function (val) {
			return console.log("POPUP ERROR", val);
		};
	
		return newWindow;
	}
	
	/**
	 * Check if a client browser is a mobile device
	 * @returns {Navigator|WorkerNavigator|Array|{index: number, input: string}}
	 */
	function isMobile() {
		return window.navigator && window.navigator.standalone || navigator.userAgent.match('CriOS') || navigator.userAgent.match(/mobile/i);
	}
	
	/**
	 * Test if a given value is empty or empty like.
	 *
	 * @param value: Value to bem asserted
	 * @param zeroIsEmpty: In case of numbers, check if zeros are considered null/empty.
	 * @returns boolean: true if is empty, false if don´t;
	 */
	function isEmpty(value) {
		var zeroIsEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		if (typeof zeroIsEmpty !== "boolean") throw new Error("zeroIsEmpty must be boolean");
	
		switch (Object.prototype.toString.call(value)) {
			case '[object Undefined]':
			case '[object Null]':
				return true;
	
			case '[object String]':
				if (value.trim().length === 0 || value.trim().toLowerCase() === 'undefined' || value.trim().toLowerCase() === 'null' || value.trim().toLowerCase() === 'empty' || value.contains("R$") && value.brazilianRealToFloat() === 0 && zeroIsEmpty) return true;
				break;
	
			case '[object Number]':
				if (zeroIsEmpty && value === 0) return true;
				break;
	
			case '[object Object]':
				if ((0, _keys2.default)(value).length === 0) return true;
				break;
	
			case '[object Array]':
				if (value.length === 0) return true;
				break;
	
			default:
				return false;
		}
	
		return false;
	}
	
	/**
	 * Check is desired param is a true JSON object
	 * @param param
	 * @returns {boolean}
	 */
	function isJson(param) {
		return Object.prototype.toString.call(param) === '[object Object]';
	}
	
	/**
	 * Cast dataUrl image to javascript blob
	 * @param dataURL
	 * @returns {*}
	 */
	function dataURLtoBlob(dataURL) {
		var BASE64_MARKER = ';base64,';
		var parts = dataURL.split(BASE64_MARKER);
		var contentType = parts[0].split(':')[1];
		var raw = window.atob(parts[1]);
		var rawLength = raw.length;
		var uInt8Array = new Uint8Array(rawLength);
		for (var i = 0; i < rawLength; ++i) {
			uInt8Array[i] = raw.charCodeAt(i);
		}
		return new Blob([uInt8Array], { type: contentType });
	}
	
	/**
	 * Generate a random color
	 */
	function generateRandomColor() {
		var letters = '0123456789'.split('');
		var color = '#';
		for (var i = 0; i < 6; i++) {
			color += letters[Math.round(Math.random() * 10)];
		}
	
		if (color.contains('undefined')) return this.generateRandomColor();
		return color;
	}
	
	/**
	 * Generate a paged array based on a base array informed
	 */
	function generatePagedArray() {
		var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var currentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
		var first = currentPage === 0 ? 0 : currentPage * pageSize;
	
		var last = void 0;
	
		if (currentPage === 0) {
			if (pageSize > array.length) last = array.length;else last = pageSize;
		} else if ((currentPage + 1) * pageSize > array.length) last = array.length;else last = (currentPage + 1) * pageSize;
	
		return {
			first: currentPage === 0,
			last: currentPage === Math.ceil(array.length / pageSize) - 1,
			totalPages: Math.ceil(array.length / pageSize),
			totalElements: array.length,
			size: pageSize,
			content: array.slice(first, last)
		};
	}
	
	/**
	 * Iterate over JSON structure and join keys and values in a single string, like:
	 * E.G:
	 *      JSON Input: {KEY:VALUE, KEY2:VALUE2}
	 *
	 *      -
	 *
	 *      String Output:
	 *
	 *      KEY:\n
	 *      VALUE\n\n
	 *
	 *      KEY2:\n
	 *      VALUE2\n\n
	 *      ...
	 *
	 * and so on.
	 *
	 * If keys are translatable, needs to pass a second function parameter of REACT translator instance, businessCause utils is outside of react domain.
	 */
	function jsonToSpecificPlainText(json, translator) {
		if (json) {
			var translate = function translate(k) {
				return translator ? translator(k) : k;
			};
			var string = "";
	
			for (var k in json) {
				if (json.hasOwnProperty(k) && !isEmpty(json[k])) string += translate(k) + ":\n" + json[k] + "\n\n";
			}return string;
		}
	
		return "";
	}
	
	/**
	 * Deep Merge JSON objects.
	 *
	 * E.g:
	 *
	 * let a = {testA: {test1: '1', test2: '1'}};
	 * let b = {testA: {test2: '2', test3: '3'}};
	 *
	 * utils.deepJsonMerge(a, b); //{test1: '1', test2: '2', test3: '3'}};
	 *
	 * @param target - let a = {testA: {test1: '1', test2: '1'}};
	 * @param source - let b = {testA: {test2: '2', test3: '3'}};
	 * @returns Deep Merged Json - {test1: '1', test2: '2', test3: '3'}};
	 */
	function deepJsonMerge() {
		var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var isObject = function isObject(item) {
			return item && (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && !Array.isArray(item);
		};
		var output = (0, _assign2.default)({}, target);
	
		if (isObject(target) && isObject(source)) {
			(0, _keys2.default)(source).forEach(function (key) {
				if (isObject(source[key])) {
					if (!(key in target)) (0, _assign2.default)(output, (0, _defineProperty3.default)({}, key, source[key]));else output[key] = deepJsonMerge(target[key], source[key]);
				} else {
					(0, _assign2.default)(output, (0, _defineProperty3.default)({}, key, source[key]));
				}
			});
		}
	
		return output;
	}
	
	/**
	 * Check if given Json has entire path of keys.
	 *
	 * E.g:
	 * Consider:
	 * let json = {level1: {level2: {level3: {level4: "hi nigga"}}}};
	 *
	 * Common undefined check can be:
	 *
	 * json.level1 && json.level1.level2 && json.level1.level2.level3 && json.level1.level2.level3.level4; //true
	 * json.level1 && json.level1.level2 && json.level1.level2.level3 && json.level1.level2.level3.levelXYZ; //false
	 *
	 * With Json Has Path:
	 *
	 * utils.jsonHasPath(json, "level1.level2.level3.level4"); //true
	 * utils.jsonHasPath(json, "level1.level2.level3.levelXYZ"); //false
	 *
	 * @param json - Desired json to check. Sample: let json = {level1: {level2: {level3: {level4: "hi nigga"}}}};
	 * @param path - Desired path to check. Must follow this sample: "level1.level2.level3.level4"
	 * @returns {boolean} - True if path is valid, false otherwise
	 */
	function jsonHasPath() {
		var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
		var args = path.split(".");
	
		for (var i = 0; i < args.length; i++) {
			if (!json || !json.hasOwnProperty(args[i])) return false;
	
			json = json[args[i]];
		}
	
		return true;
	}
	
	exports.default = {
		uuid: uuid,
		halfUuid: halfUuid,
		resolveBrowserLanguage: resolveBrowserLanguage,
		jsonToQueryString: jsonToQueryString,
		popupCenter: popupCenter,
		isMobile: isMobile,
		isEmpty: isEmpty,
		isJson: isJson,
		dataURLtoBlob: dataURLtoBlob,
		deepJsonMerge: deepJsonMerge,
		jsonHasPath: jsonHasPath,
		generateRandomColor: generateRandomColor,
		generatePagedArray: generatePagedArray,
		jsonToSpecificPlainText: jsonToSpecificPlainText
	};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _common = __webpack_require__(519);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _views = __webpack_require__(524);
	
	var _views2 = _interopRequireDefault(_views);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Components Main module
	 */
	exports.default = _angular2.default.module('app.components', [_common2.default, _views2.default]).name;

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _exLabel = __webpack_require__(520);
	
	var _exLabel2 = _interopRequireDefault(_exLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Common main module
	 */
	exports.default = _angular2.default.module('app.components.common', [_exLabel2.default]).name;

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _exLabelTemplate = __webpack_require__(521);
	
	var _exLabelTemplate2 = _interopRequireDefault(_exLabelTemplate);
	
	var _exLabel = __webpack_require__(522);
	
	var _exLabel2 = _interopRequireDefault(_exLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('exLabel', [_angularjs2.default]).component('exLabel', {
		bindings: {
			page: '@',
			key: '@'
		},
		template: _exLabelTemplate2.default,
		controller: _exLabel2.default
	}).name;

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

	module.exports = "{{$ctrl.label}}"

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Simple component to resolve label from WordPress Template
	 */
	var ExLabel = function ExLabel($scope, $rootScope, $element, $attrs, labelService) {
		'ngInject';
	
		var _this = this;
	
		(0, _classCallCheck3.default)(this, ExLabel);
		var labels = {};
		this.label = "no-label-found";
		$scope.count = 1;
	
		$scope.$watch("this.page", function () {
			if (_this.page && _this.key) {
				labels = labelService.getLabelsByPage(_this.page);
				_this.label = labels[_this.key];
			}
		});
	
		$rootScope.$on("labelService:labelsChanged", function (event, newLabels) {
			_this.label = newLabels[_this.page][_this.key];
			$scope.$apply();
		});
	};
	ExLabel.$inject = ["$scope", "$rootScope", "$element", "$attrs", "labelService"];
	
	exports.default = ExLabel;

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRecaptcha = __webpack_require__(525);
	
	var _angularRecaptcha2 = _interopRequireDefault(_angularRecaptcha);
	
	var _angularInputMasks = __webpack_require__(527);
	
	var _angularInputMasks2 = _interopRequireDefault(_angularInputMasks);
	
	var _angularUiMask = __webpack_require__(594);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	var _angularUiBootstrap = __webpack_require__(596);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _login = __webpack_require__(598);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _tokenEmail = __webpack_require__(771);
	
	var _tokenEmail2 = _interopRequireDefault(_tokenEmail);
	
	var _tokenSms = __webpack_require__(776);
	
	var _tokenSms2 = _interopRequireDefault(_tokenSms);
	
	var _question = __webpack_require__(781);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _password = __webpack_require__(786);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _success = __webpack_require__(793);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _blockpassword = __webpack_require__(798);
	
	var _blockpassword2 = _interopRequireDefault(_blockpassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Views main module
	 */
	var views = _angular2.default.module('app.components.views', [_angularRecaptcha2.default, _angularInputMasks2.default, _angularUiMask2.default, _angularUiBootstrap2.default, _login2.default, _tokenEmail2.default, _tokenSms2.default, _question2.default, _password2.default, _blockpassword2.default, _success2.default]).config(["vcRecaptchaServiceProvider", function (vcRecaptchaServiceProvider) {
		"ngInject";
	
		vcRecaptchaServiceProvider.setDefaults({
			key: '6LdhGlcUAAAAAGkqOjNF5AJ_UlBarNXUMepU3oZ1',
			theme: 'light',
			size: 'normal',
			type: 'image',
			lang: 'pt-BR'
		});
	}])
	
	//comentar para parar desativar o redirecionamento automático para a home
	.run(["uiMaskConfig", "$transitions", "Restangular", "$state", function (uiMaskConfig, $transitions, Restangular, $state) {
		"ngInject";
	
		uiMaskConfig.clearOnBlur = false;
	
		// Pseudo-Simple security.
		$transitions.onSuccess({ to: '*' }, function (transition) {
			if ($state.current.name !== "login" && $state.current.name !== "blockpassword" && !Restangular.defaultHeaders.Authorization) $state.go("login");
		});
	}]);
	
	exports.default = views.name;

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _loginTemplate = __webpack_require__(599);
	
	var _loginTemplate2 = _interopRequireDefault(_loginTemplate);
	
	var _login = __webpack_require__(600);
	
	var _login2 = _interopRequireDefault(_login);
	
	__webpack_require__(769);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Login View Module
	 */
	exports.default = _angular2.default.module('login', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$urlRouterProvider.otherwise('/');
		$stateProvider.state('login', {
			url: '/',
			component: 'login'
		});
	}]).component('login', {
		bindings: {},
		template: _loginTemplate2.default,
		controller: _login2.default
	}).name;

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-15 pt-15\">\n    <form id=\"form\" name=\"form\" novalidate ng-submit=\"$ctrl.initPasswordRecoveryProcess()\">\n        <div>{{'login:welcomeText3' | cfLabel}}</div>\n        <br />\n\n        <fieldset class=\"pt-5\">\n            <div class=\"form-group\"\n                 ng-class=\"{'has-error' : form.cpfField.$touched && (form.cpfField.$error | json) !== '{}'}\">\n                <label for=\"cpfField\">\n                    {{'login:cpfField' | cfLabel}}\n                </label>\n                <input id=\"cpfField\"\n                       name=\"cpfField\"\n                       ex-autofocus\n                       class=\"form-control\"\n                       type=\"tel\"\n                       ng-model=\"$ctrl.personalData.cpf\"\n                       ng-disabled=\"$ctrl.loading\"\n                       style=\"white-space: normal;\"\n                       required\n                       ui-br-cpf-mask\n                       maxlength=\"14\"\n                       onkeypress=\"setTimeout(function () { this.value = this.value}.bind(this), 100)\"\n                />\n\n                <div class=\"help-block\">\n\t                <span ng-if=\"form.cpfField.$touched && form.cpfField.$error.required\">\n\t                    {{'global:required' | cfLabel}}\n\t                </span>\n                    <span ng-if=\"form.cpfField.$touched && form.cpfField.$error.cpf\">\n\t                    {{'login:invalidCpf' | cfLabel}}\n\t                </span>\n                </div>\n            </div>\n\n            <div class=\"form-group\"\n                 ng-class=\"{'has-error' : form.birthdayField.$touched && (form.birthdayField.$error | json) !== '{}'}\">\n                <label for=\"birthdayField\">\n                    {{'login:birthdayField' | cfLabel}}\n                </label>\n                <div class=\"input-group\">\n                    <input id=\"birthdayField\"\n                           name=\"birthdayField\"\n                           type=\"tel\"\n                           class=\"form-control\"\n                           ui-mask=\"99/99/9999\"\n                           model-view-value=\"true\"\n                           no-future-dates=\"DD/MM/YYYY\"\n                           uib-datepicker-popup=\"dd/MM/yyyy\"\n                           ng-model=\"$ctrl.personalData.birthday\"\n                           is-open=\"$ctrl.bdPickerOpen\"\n                           datepicker-options=\"$ctrl.bdDateOptions\"\n                           show-button-bar=\"false\"\n                           ng-required=\"true\"\n                           ng-disabled=\"$ctrl.loading\"\n                           maxlength=\"10\"/>\n                    <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.toggleBDPicker()\"\n                            ng-disabled=\"$ctrl.loading\">\n                        <i class=\"glyphicon glyphicon-calendar\"></i>\n                    </button>\n                </span>\n                </div>\n\n                <div class=\"help-block\">\n\t                <span ng-if=\"form.birthdayField.$touched && form.birthdayField.$error.required\">\n\t                    {{'global:required' | cfLabel}}\n\t                </span>\n                    <span ng-if=\"form.birthdayField.$touched && form.birthdayField.$error.date && !form.birthdayField.$error.required\">\n\t                    {{'login:invalidBirthday' | cfLabel}}\n\t                </span>\n                    </span>\n                    <span ng-if=\"form.birthdayField.$touched && form.birthdayField.$error.isFutureDate && !form.birthdayField.$error.date\">\n\t                    {{'login:invalidBirthday' | cfLabel}}\n\t                </span>\n                </div>\n            </div>\n\n            <div id=\"turnstile-widget\" class=\"form-group\" ng-if=\"!$ctrl.automateTest\" data-theme=\"light\"></div>\n\n            <div class=\"linhaTop\">&nbsp;</div>\n\n            <button type=\"submit\"\n                    title=\"{{'global:nextBtnDesc' | cfLabel}}\"\n                    ng-class=\"form.$invalid || form.$pristine || $ctrl.loading || !$ctrl.captchaToken ? 'btn btn-lg corDisable btn-block':'btn btn-lg btn-cooperforte btn-block'\"\n                    ng-disabled=\"form.$invalid || form.$pristine || $ctrl.loading\">\n                <span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n                {{'global:nextBtn' | cfLabel}}\n            </button>\n            <div><br>\n                <p class=\"text-justify\" style=\"font-size:.8em;\"><strong>Pessoa Jurídica:</strong> Entre em contato com a COOPERFORTE pelos telefones 4007 2762 (Capitais e Regi&otildees Metropolitanas) ou 0800 701 3766 (Demais localidades) </p></div>\n        </fieldset>\n    </form>\n</div>\n\n<!-- 200 Notification Sms Modal -->\n<script type=\"text/ng-template\" id=\"notificationSms.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{'login:titleModalRPStarted' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body\">\n        <p class=\"texto-passo\">Passo 2 de 4</p>\n        <p ng-if=\"$ctrl.process.mobileNumber\" class=\"text-justify \">{{'tokenSms:text1ModalRPStartedSms' | cfLabel}}</p>\n        <p ng-if=\"$ctrl.process.mobileNumber\" class=\"text-justify \">{{'login:text2ModalRPStarted' | cfLabel}}</p>\n        <br>\n        <label for=\"celular\">Celular</label>\n        <div class=\"text-center form-control\" id=\"celular\">\n            <strong ng-if=\"$ctrl.process.mobileNumber\">\n                ** ***** - *{{$ctrl.process.mobileNumber}}\n            </strong>\n            <strong ng-if=\"!$ctrl.process.mobileNumber\">\n                Você não possui celular cadastrado.\n            </strong>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n                title=\"{{'global:continueProcessBtnDesc' | cfLabel}}\">\n            {{'global:continueProcessBtn' | cfLabel}}\n        </button>\n    </div>\n\n</script>\n\n<!-- 406 Prospect em associação Modal -->\n<script type=\"text/ng-template\" id=\"modalProspectEmAssociacao.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{'login:titleModal406Error' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body text-justify\">\n        <p>{{'login:textModal406rror1' | cfLabel}}</p>\n        <p>{{'login:textModal406rror2' | cfLabel}}</p>\n        <p>{{'login:textModal406rror3' | cfLabel}}</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n                title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n            {{'global:closeBtn' | cfLabel}}\n        </button>\n    </div>\n</script>\n\n\n<!-- 40x errorNotification Modal -->\n<script type=\"text/ng-template\" id=\"errorNotification.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{'login:titleModal'+$ctrl.code+'Error' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body text-justify\">\n        <p ng-if=\"$ctrl.code !== 400\">{{'login:textModal'+$ctrl.code+'Error' | cfLabel}}</p>\n        <p ng-if=\"$ctrl.code === 400\">{{'login:semEmailECelular1' | cfLabel}}</p>\n\n        <div ng-if=\"$ctrl.code === 403 || $ctrl.code === 400 || $ctrl.code === 401\" class=\"text-center\">\n            <div ng-if=\"$ctrl.code !== 400\">{{'global:labelSupportCentral' | cfLabel}}</div>\n            <br/>\n            <strong>\n                {{'global:centralTelephoneNumber' | cfLabel}}\n            </strong>\n            <br/>\n            <strong>\n                {{'global:centralTelephoneNumber2' | cfLabel}}\n            </strong>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n                title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n            {{'global:closeBtn' | cfLabel}}\n        </button>\n    </div>\n</script>"

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(601);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(604);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _asyncToGenerator2 = __webpack_require__(605);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(629);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Login controller
	 */
	var LoginController = function () {
		LoginController.$inject = ["recoveryPasswordService", "$scope", "$location", "$uibModal", "$state"];
		function LoginController(recoveryPasswordService, $scope, $location, $uibModal, $state) {
			'ngInject';
	
			//Exposing globals to another methods
	
			var _this = this;
	
			(0, _classCallCheck3.default)(this, LoginController);
	
			this.toggleBDPicker = function () {
				_this.bdPickerOpen = !_this.bdPickerOpen;
			};
	
			setTimeout(function () {
				return _this.renderTurnstile();
			}, 100);
			this.recoveryPasswordService = recoveryPasswordService;
			this.$scope = $scope;
			this.$uibModal = $uibModal;
			this.$state = $state;
	
			this.bdPickerOpen = false;
			this.bdDateOptions = {
				dateDisabled: false,
				formatYear: 'yy',
				maxDate: new Date(),
				startingDay: 1
			};
	
			this.loading = false;
			this.automateTest = !!$location.search().automateTest;
			this.captchaToken = null;
	
			sessionStorage.removeItem('deviceInfos');
		}
	
		/**
	  * Open or close birthday date picker popup
	  */
	
	
		(0, _createClass3.default)(LoginController, [{
			key: 'initPasswordRecoveryProcess',
	
	
			/**
	   * Get validated user inputs and initialize the process of password recovery
	   */
			value: function () {
				var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
					var result, personalDataAsString, data;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
	
									sessionStorage.removeItem('showIdentityQuestion');
	
									if (!this.$scope.form.$invalid) {
										_context.next = 3;
										break;
									}
	
									return _context.abrupt('return');
	
								case 3:
	
									this.loading = true;
	
									result = void 0;
									personalDataAsString = (0, _extends3.default)({}, this.personalData);
									data = personalDataAsString.birthday;
	
									data.setTime(data.getTime() + 3 * 60 * 60 * 1000);
	
									personalDataAsString.birthday = (0, _moment2.default)(data).format("YYYY-MM-DD");
									personalDataAsString['captchaToken'] = this.captchaToken;
	
									_context.next = 12;
									return this.recoveryPasswordService.initRecoverPasswordProcess(personalDataAsString).catch(function (e) {
										return result = e;
									});
	
								case 12:
									result = _context.sent;
	
									if (!(result.status === 200)) {
										_context.next = 20;
										break;
									}
	
									sessionStorage.setItem("idProcesso", result.data.payload.idProcesso);
									_context.next = 17;
									return this.recoveryPasswordService.sendSmsToken();
	
								case 17:
									this.showNotificationSmsModal(result.data.payload);
									_context.next = 21;
									break;
	
								case 20:
									if (result.status === 406) {
										this.showProspectModal(result.status);
									} else if ([400, 401, 403, 404].contains(result.status)) {
										this.show40XNotificationModal(result.status);
									}
	
								case 21:
									this.loading = false;
									this.$scope.$apply();
	
								case 23:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, this);
				}));
	
				function initPasswordRecoveryProcess() {
					return _ref.apply(this, arguments);
				}
	
				return initPasswordRecoveryProcess;
			}()
		}, {
			key: 'showNotificationSmsModal',
	
	
			/**
	   * 200 - Process Started Notification Modal
	   */
			value: function showNotificationSmsModal(_process) {
				var _this2 = this;
	
				var modalInstance = this.$uibModal.open({
					animation: true,
					templateUrl: 'notificationSms.modal.html',
					controllerAs: '$ctrl',
					size: "sm",
					controller: ["$scope", "process", function controller($scope, process) {
						"ngInject";
	
						var $ctrl = $scope.$ctrl;
						$ctrl.process = process;
	
						$ctrl.ok = function () {
							return modalInstance.close();
						};
					}],
					resolve: {
						process: function process() {
							return _process;
						}
					}
				});
				modalInstance.result.then(function () {
					return _this2.$state.go("tokenSms");
				});
			}
		}, {
			key: 'show40XNotificationModal',
	
	
			/**
	   * 40X - Error Notification Modal
	   */
			value: function show40XNotificationModal(_code) {
				var modalInstance = this.$uibModal.open({
					animation: true,
					templateUrl: 'errorNotification.modal.html',
					controllerAs: '$ctrl',
					size: "sm",
					controller: ["$scope", "code", function controller($scope, code) {
						"ngInject";
	
						var $ctrl = $scope.$ctrl;
	
						$ctrl.code = code;
						$ctrl.ok = function () {
							modalInstance.close();
						};
					}],
					resolve: {
						code: function code() {
							return _code;
						}
					}
				});
			}
		}, {
			key: 'showProspectModal',
			value: function showProspectModal(_code2) {
				var modalInstance = this.$uibModal.open({
					animation: true,
					templateUrl: 'modalProspectEmAssociacao.modal.html',
					controllerAs: '$ctrl',
					size: "sm",
					controller: ["$scope", "code", function controller($scope, code) {
						"ngInject";
	
						var $ctrl = $scope.$ctrl;
	
						$ctrl.code = code;
						$ctrl.ok = function () {
							modalInstance.close();
						};
					}],
					resolve: {
						code: function code() {
							return _code2;
						}
					}
				});
			}
		}, {
			key: 'renderTurnstile',
			value: function renderTurnstile() {
				var _this3 = this;
	
				var tryRender = function tryRender() {
					var el = document.getElementById('turnstile-widget');
					if (typeof turnstile !== 'undefined' && el && el.childElementCount === 0) {
						turnstile.render(el, {
							sitekey: '0x4AAAAAABgoi_-GJRL4WzV_',
							callback: function callback(token) {
								_this3.captchaToken = token;
								_this3.$scope.$applyAsync();
							},
							'expired-callback': function expiredCallback() {
								_this3.captchaToken = null;
								_this3.$scope.$applyAsync();
							},
							'error-callback': function errorCallback() {
								_this3.captchaToken = null;
								_this3.$scope.$applyAsync();
							}
						});
					} else {
						setTimeout(tryRender, 300);
					}
				};
	
				tryRender();
			}
		}]);
		return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 632,
		"./af.js": 632,
		"./ar": 633,
		"./ar-dz": 634,
		"./ar-dz.js": 634,
		"./ar-kw": 635,
		"./ar-kw.js": 635,
		"./ar-ly": 636,
		"./ar-ly.js": 636,
		"./ar-ma": 637,
		"./ar-ma.js": 637,
		"./ar-ps": 638,
		"./ar-ps.js": 638,
		"./ar-sa": 639,
		"./ar-sa.js": 639,
		"./ar-tn": 640,
		"./ar-tn.js": 640,
		"./ar.js": 633,
		"./az": 641,
		"./az.js": 641,
		"./be": 642,
		"./be.js": 642,
		"./bg": 643,
		"./bg.js": 643,
		"./bm": 644,
		"./bm.js": 644,
		"./bn": 645,
		"./bn-bd": 646,
		"./bn-bd.js": 646,
		"./bn.js": 645,
		"./bo": 647,
		"./bo.js": 647,
		"./br": 648,
		"./br.js": 648,
		"./bs": 649,
		"./bs.js": 649,
		"./ca": 650,
		"./ca.js": 650,
		"./cs": 651,
		"./cs.js": 651,
		"./cv": 652,
		"./cv.js": 652,
		"./cy": 653,
		"./cy.js": 653,
		"./da": 654,
		"./da.js": 654,
		"./de": 655,
		"./de-at": 656,
		"./de-at.js": 656,
		"./de-ch": 657,
		"./de-ch.js": 657,
		"./de.js": 655,
		"./dv": 658,
		"./dv.js": 658,
		"./el": 659,
		"./el.js": 659,
		"./en-au": 660,
		"./en-au.js": 660,
		"./en-ca": 661,
		"./en-ca.js": 661,
		"./en-gb": 662,
		"./en-gb.js": 662,
		"./en-ie": 663,
		"./en-ie.js": 663,
		"./en-il": 664,
		"./en-il.js": 664,
		"./en-in": 665,
		"./en-in.js": 665,
		"./en-nz": 666,
		"./en-nz.js": 666,
		"./en-sg": 667,
		"./en-sg.js": 667,
		"./eo": 668,
		"./eo.js": 668,
		"./es": 669,
		"./es-do": 670,
		"./es-do.js": 670,
		"./es-mx": 671,
		"./es-mx.js": 671,
		"./es-us": 672,
		"./es-us.js": 672,
		"./es.js": 669,
		"./et": 673,
		"./et.js": 673,
		"./eu": 674,
		"./eu.js": 674,
		"./fa": 675,
		"./fa.js": 675,
		"./fi": 676,
		"./fi.js": 676,
		"./fil": 677,
		"./fil.js": 677,
		"./fo": 678,
		"./fo.js": 678,
		"./fr": 679,
		"./fr-ca": 680,
		"./fr-ca.js": 680,
		"./fr-ch": 681,
		"./fr-ch.js": 681,
		"./fr.js": 679,
		"./fy": 682,
		"./fy.js": 682,
		"./ga": 683,
		"./ga.js": 683,
		"./gd": 684,
		"./gd.js": 684,
		"./gl": 685,
		"./gl.js": 685,
		"./gom-deva": 686,
		"./gom-deva.js": 686,
		"./gom-latn": 687,
		"./gom-latn.js": 687,
		"./gu": 688,
		"./gu.js": 688,
		"./he": 689,
		"./he.js": 689,
		"./hi": 690,
		"./hi.js": 690,
		"./hr": 691,
		"./hr.js": 691,
		"./hu": 692,
		"./hu.js": 692,
		"./hy-am": 693,
		"./hy-am.js": 693,
		"./id": 694,
		"./id.js": 694,
		"./is": 695,
		"./is.js": 695,
		"./it": 696,
		"./it-ch": 697,
		"./it-ch.js": 697,
		"./it.js": 696,
		"./ja": 698,
		"./ja.js": 698,
		"./jv": 699,
		"./jv.js": 699,
		"./ka": 700,
		"./ka.js": 700,
		"./kk": 701,
		"./kk.js": 701,
		"./km": 702,
		"./km.js": 702,
		"./kn": 703,
		"./kn.js": 703,
		"./ko": 704,
		"./ko.js": 704,
		"./ku": 705,
		"./ku-kmr": 706,
		"./ku-kmr.js": 706,
		"./ku.js": 705,
		"./ky": 707,
		"./ky.js": 707,
		"./lb": 708,
		"./lb.js": 708,
		"./lo": 709,
		"./lo.js": 709,
		"./lt": 710,
		"./lt.js": 710,
		"./lv": 711,
		"./lv.js": 711,
		"./me": 712,
		"./me.js": 712,
		"./mi": 713,
		"./mi.js": 713,
		"./mk": 714,
		"./mk.js": 714,
		"./ml": 715,
		"./ml.js": 715,
		"./mn": 716,
		"./mn.js": 716,
		"./mr": 717,
		"./mr.js": 717,
		"./ms": 718,
		"./ms-my": 719,
		"./ms-my.js": 719,
		"./ms.js": 718,
		"./mt": 720,
		"./mt.js": 720,
		"./my": 721,
		"./my.js": 721,
		"./nb": 722,
		"./nb.js": 722,
		"./ne": 723,
		"./ne.js": 723,
		"./nl": 724,
		"./nl-be": 725,
		"./nl-be.js": 725,
		"./nl.js": 724,
		"./nn": 726,
		"./nn.js": 726,
		"./oc-lnc": 727,
		"./oc-lnc.js": 727,
		"./pa-in": 728,
		"./pa-in.js": 728,
		"./pl": 729,
		"./pl.js": 729,
		"./pt": 730,
		"./pt-br": 731,
		"./pt-br.js": 731,
		"./pt.js": 730,
		"./ro": 732,
		"./ro.js": 732,
		"./ru": 733,
		"./ru.js": 733,
		"./sd": 734,
		"./sd.js": 734,
		"./se": 735,
		"./se.js": 735,
		"./si": 736,
		"./si.js": 736,
		"./sk": 737,
		"./sk.js": 737,
		"./sl": 738,
		"./sl.js": 738,
		"./sq": 739,
		"./sq.js": 739,
		"./sr": 740,
		"./sr-cyrl": 741,
		"./sr-cyrl.js": 741,
		"./sr.js": 740,
		"./ss": 742,
		"./ss.js": 742,
		"./sv": 743,
		"./sv.js": 743,
		"./sw": 744,
		"./sw.js": 744,
		"./ta": 745,
		"./ta.js": 745,
		"./te": 746,
		"./te.js": 746,
		"./tet": 747,
		"./tet.js": 747,
		"./tg": 748,
		"./tg.js": 748,
		"./th": 749,
		"./th.js": 749,
		"./tk": 750,
		"./tk.js": 750,
		"./tl-ph": 751,
		"./tl-ph.js": 751,
		"./tlh": 752,
		"./tlh.js": 752,
		"./tr": 753,
		"./tr.js": 753,
		"./tzl": 754,
		"./tzl.js": 754,
		"./tzm": 755,
		"./tzm-latn": 756,
		"./tzm-latn.js": 756,
		"./tzm.js": 755,
		"./ug-cn": 757,
		"./ug-cn.js": 757,
		"./uk": 758,
		"./uk.js": 758,
		"./ur": 759,
		"./ur.js": 759,
		"./uz": 760,
		"./uz-latn": 761,
		"./uz-latn.js": 761,
		"./uz.js": 760,
		"./vi": 762,
		"./vi.js": 762,
		"./x-pseudo": 763,
		"./x-pseudo.js": 763,
		"./yo": 764,
		"./yo.js": 764,
		"./zh-cn": 765,
		"./zh-cn.js": 765,
		"./zh-hk": 766,
		"./zh-hk.js": 766,
		"./zh-mo": 767,
		"./zh-mo.js": 767,
		"./zh-tw": 768,
		"./zh-tw.js": 768
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 631;


/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(770);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./login.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./login.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "login{width:100%;height:100%}.recaptcha-fix{max-width:inherit;overflow:hidden}.corCinzaClaro{background-color:#efefef;border:1px solid #ddd}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}", ""]);
	
	// exports


/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _tokenEmailTemplate = __webpack_require__(772);
	
	var _tokenEmailTemplate2 = _interopRequireDefault(_tokenEmailTemplate);
	
	var _tokenEmail = __webpack_require__(773);
	
	var _tokenEmail2 = _interopRequireDefault(_tokenEmail);
	
	__webpack_require__(774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Token Verification View Module
	 */
	exports.default = _angular2.default.module('tokenEmail', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('tokenEmail', {
			url: '/confirmacao-token-email',
			component: 'tokenEmail'
		});
	}]).component('tokenEmail', {
		bindings: {},
		template: _tokenEmailTemplate2.default,
		controller: _tokenEmail2.default
	}).name;

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10\">\n\t<form class=\"col-sm-12\" id=\"form\" name=\"form\" novalidate ng-submit=\"$ctrl.confirmVerificationToken()\">\n\t\t<p class=\"welcome-texts\">\n\t\t\t{{'tokenEmail:welcomeText' | cfLabel}}\n\t\t</p>\n\n\t\t<fieldset class=\"pt-5\">\n\t\t\t<div class=\"form-group\"\n\t\t\t     ng-class=\"{'has-error' : form.tokenField.$touched && (form.tokenField.$error | json) !== '{}'}\">\n\t\t\t\t<label for=\"tokenField\" style=\"width: 100%; text-align: center;\">\n\t\t\t\t\t{{'tokenEmail:confirmationToken' | cfLabel}}\n\t\t\t\t</label>\n\t\t\t\t<input id=\"tokenField\"\n\t\t\t\t       name=\"tokenField\"\n\t\t\t\t       ex-autofocus\n\t\t\t\t       class=\"form-control\"\n\t\t\t\t       type=\"tel\"\n\t\t\t\t       ui-mask=\"999999\"\n\t\t\t\t       ui-mask-placeholder-char=\"space\"\n\t\t\t\t       ng-model=\"$ctrl.token\"\n\t\t\t\t       ng-disabled=\"$ctrl.loading\"\n\t\t\t\t       required\n\t\t\t\t       maxlength=\"6\"\n\t\t\t\t       style=\"margin: 10px auto; width: 100%; font-size: 3em; border-radius: 5px; width: 90%; text-align: center; font-size: 20px; letter-spacing:20px;\"/>\n\t\t\t\t<div class=\"help-block\">\n\t                <span ng-if=\"form.tokenField.$touched && form.tokenField.$error.required\">\n\t                    {{'tokenEmail:required' | cfLabel}}\n\t                </span>\n\t\t\t\t\t<span ng-if=\"form.tokenField.$touched && form.tokenField.$error.mask\">\n\t                    {{'tokenEmail:incompleteCode' | cfLabel}}\n\t                </span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"linhaTop\">&nbsp;</div>\n\t\t\t<div class=\"pt-15\">\n\t\t\t\t<button type=\"submit\"\n\t\t\t\t        title=\"{{'tokenEmail:validateBtnDesc' | cfLabel}}\"\n\t\t\t\t\t\tng-class=\"form.$invalid || form.$pristine || $ctrl.loading ? 'btn btn-lg corDisable btn-block':'btn btn-lg btn-cooperforte btn-block'\"\n\t\t\t\t        ng-disabled=\"form.$invalid || form.$pristine || $ctrl.loading\">\n\t\t\t\t\t<span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n\t\t\t\t\t{{'tokenEmail:validateBtn' | cfLabel}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<div class=\"panel-footer pY-20 footer-token\">\n\t<div class=\"text-justify\">\n\t\t{{'tokenEmail:footerText1' | cfLabel}}\n\t\t<strong>{{'tokenEmail:footerText2' | cfLabel}}</strong>\n\t</div>\n</div>\n\n<!-- 200 Token Valid Notification Modal -->\n<script type=\"text/ng-template\" id=\"tokenEmailValidNotification.modal.html\">\n\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{'tokenEmail:titleModalTokenValid' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\n\t<div class=\"modal-body\">\n\t\t<p>{{'tokenEmail:textModalTokenValid' | cfLabel}}</p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t        title=\"{{'global:continueProcessBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:continueProcessBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n\n<!-- 200 Notification Sms Modal -->\n<script type=\"text/ng-template\" id=\"notificationSms.modal.html\">\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{'login:titleModalRPStarted' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<p class=\"texto-passo\">Passo 2 de 4</p>\n\t\t<p ng-if=\"$ctrl.process.celular\" class=\"text-justify \">{{'tokenSms:text1ModalRPStartedSms' | cfLabel}}</p>\n\t\t<p ng-if=\"$ctrl.process.celular\" class=\"text-justify \">{{'login:text2ModalRPStarted' | cfLabel}}</p>\n\t\t<br>\n\t\t<label for=\"celular\">Celular</label>\n\t\t<div class=\"text-center form-control\" id=\"celular\">\n\t\t\t<strong ng-if=\"$ctrl.process.celular\">\n\t\t\t\t** ***** - *{{$ctrl.process.celular.substring(8, 11)}}\n\t\t\t</strong>\n\t\t\t<strong ng-if=\"!$ctrl.process.celular\">\n\t\t\t\tVocê não possui celular cadastrado.\n\t\t\t</strong>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t\t\ttitle=\"{{'global:continueProcessBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:continueProcessBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n\n</script>\n\n<!-- 40X Invalid Token Notification Modal -->\n<script type=\"text/ng-template\" id=\"invalidTokenEmailNotification.modal.html\">\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{$ctrl.code == 400 ? 'tokenEmail:titleModalTokenValid' : 'global:titleModal'+$ctrl.code+'Error' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\t<div class=\"modal-body text-justify\">\n\t\t<p>{{$ctrl.code === 400 ? 'tokenEmail:textModal400Error' : 'global:textModal'+$ctrl.code+'Error'| cfLabel}}</p>\n\t\t<div ng-if=\"$ctrl.code === 403\" class=\"text-center\">\n\t\t\t{{'global:labelSupportCentral' | cfLabel}}\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber' | cfLabel}}\n\t\t\t</strong>\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber2' | cfLabel}}\n\t\t\t</strong>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.code === 404\" class=\"text-center\">\n\t\t\t{{'global:textModal404InvalidInformation' | cfLabel}}\n\t\t\t<br/><br/>\n\t\t\t{{'global:labelSupportCentral' | cfLabel}}\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber' | cfLabel}}\n\t\t\t</strong>\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber2' | cfLabel}}\n\t\t\t</strong>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t        title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:closeBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(601);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(605);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Token Verification Controller
	 */
	var TokenEmailController = function () {
	    TokenEmailController.$inject = ["recoveryPasswordService", "$scope", "$uibModal", "$state"];
	    function TokenEmailController(recoveryPasswordService, $scope, $uibModal, $state) {
	        'ngInject';
	
	        //Exposing globals to another methods
	
	        (0, _classCallCheck3.default)(this, TokenEmailController);
	        this.recoveryPasswordService = recoveryPasswordService;
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	
	        this.loading = false;
	        this.token = "";
	    }
	
	    /**
	     * Submit token
	     */
	
	
	    (0, _createClass3.default)(TokenEmailController, [{
	        key: 'confirmVerificationToken',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	                var result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!this.$scope.form.$invalid) {
	                                    _context.next = 2;
	                                    break;
	                                }
	
	                                return _context.abrupt('return');
	
	                            case 2:
	
	                                this.loading = true;
	
	                                result = void 0;
	                                _context.next = 6;
	                                return this.recoveryPasswordService.confirmEmailVerificationToken(this.token).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 6:
	                                result = _context.sent;
	
	                                if (!(result.status === 200)) {
	                                    _context.next = 14;
	                                    break;
	                                }
	
	                                _context.next = 10;
	                                return this.recoveryPasswordService.sendSmsToken().catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 10:
	                                result = _context.sent;
	
	                                if (result.status === 200) {
	                                    this.showValidTokenModal(result.data);
	                                } else {
	                                    this.showInvalidTokenModal(result.status);
	                                }
	                                _context.next = 15;
	                                break;
	
	                            case 14:
	                                if ([400, 401, 403].contains(result.status)) {
	                                    this.showInvalidTokenModal(result.status);
	                                }
	
	                            case 15:
	                                this.loading = false;
	                                this.$scope.$apply();
	
	                            case 17:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function confirmVerificationToken() {
	                return _ref.apply(this, arguments);
	            }
	
	            return confirmVerificationToken;
	        }()
	
	        /**
	         * 200 - Process Started Notification Modal
	         */
	
	    }, {
	        key: 'showValidTokenModal',
	        value: function showValidTokenModal(result) {
	            var _this = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'tokenEmailValidNotification.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", function controller($scope) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }]
	            });
	            modalInstance.result.then(function () {
	                _this.showNotificationSmsModal(result);
	            });
	        }
	    }, {
	        key: 'showNotificationSmsModal',
	        value: function showNotificationSmsModal(_process) {
	            var _this2 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'notificationSms.modal.html',
	                controllerAs: '$ctrl',
	                size: "sm",
	                controller: ["$scope", "process", function controller($scope, process) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	                    $ctrl.process = process;
	
	                    $ctrl.ok = function () {
	                        return modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    process: function process() {
	                        return _process;
	                    }
	                }
	            });
	            sessionStorage.setItem("idProcesso", _process.id);
	            modalInstance.result.then(function () {
	                return _this2.$state.go("tokenSms");
	            });
	        }
	    }, {
	        key: 'showInvalidTokenModal',
	
	
	        /**
	         * 40X - Error Notification Modal
	         */
	        value: function showInvalidTokenModal(_code) {
	            var _this3 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'invalidTokenEmailNotification.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", "code", function controller($scope, code) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.code = code;
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    code: function code() {
	                        return _code;
	                    }
	                }
	            });
	
	            modalInstance.result.then(function () {
	                if (_code > 400) _this3.$state.go("login");
	            }, function () {
	                if (_code > 403) _this3.$state.go("login");
	            });
	        }
	    }]);
	    return TokenEmailController;
	}();
	
	exports.default = TokenEmailController;

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(775);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tokenEmail.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tokenEmail.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "token{width:100%;height:100%}.footer-token{font-size:12px}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}", ""]);
	
	// exports


/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _tokenSmsTemplate = __webpack_require__(777);
	
	var _tokenSmsTemplate2 = _interopRequireDefault(_tokenSmsTemplate);
	
	var _tokenSms = __webpack_require__(778);
	
	var _tokenSms2 = _interopRequireDefault(_tokenSms);
	
	__webpack_require__(779);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Token Verification View Module
	 */
	exports.default = _angular2.default.module('tokenSms', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('tokenSms', {
			url: '/confirmacao-token-sms',
			component: 'tokenSms'
		});
	}]).component('tokenSms', {
		bindings: {},
		template: _tokenSmsTemplate2.default,
		controller: _tokenSms2.default
	}).name;

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10\">\n\t<form class=\"col-sm-12\" id=\"form\" name=\"form\" novalidate ng-submit=\"$ctrl.confirmVerificationToken()\">\n\t\t<p class=\"welcome-texts\">\n\t\t\t{{$ctrl.labelTipoEnvio === 'SMS' ? 'tokenSms:welcomeText' : 'newTokenWhatsApp:welcomeText' | cfLabel}}\n\t\t</p>\n\n\t\t<fieldset class=\"pt-5\">\n\t\t\t<div class=\"form-group\"\n\t\t\t     ng-class=\"{'has-error' : form.tokenField.$touched && (form.tokenField.$error | json) !== '{}'}\">\n\t\t\t\t<label for=\"tokenField\" style=\"width: 100%; text-align: center;\">\n\t\t\t\t\t{{'tokenSms:confirmationToken' | cfLabel}}\n\t\t\t\t</label>\n\t\t\t\t<input id=\"tokenField\"\n\t\t\t\t       name=\"tokenField\"\n\t\t\t\t       ex-autofocus\n\t\t\t\t       class=\"form-control\"\n\t\t\t\t       type=\"tel\"\n\t\t\t\t       ui-mask=\"999999\"\n\t\t\t\t       ui-mask-placeholder-char=\"space\"\n\t\t\t\t       ng-model=\"$ctrl.token\"\n\t\t\t\t       ng-disabled=\"$ctrl.loading\"\n\t\t\t\t       required\n\t\t\t\t       maxlength=\"6\"\n\t\t\t\t       style=\"margin: 10px auto; width: 100%; font-size: 3em; border-radius: 5px; width: 90%; text-align: center; font-size: 20px; letter-spacing:20px;\"/>\n\t\t\t\t<div class=\"help-block\">\n\t                <span ng-if=\"form.tokenField.$touched && form.tokenField.$error.required\">\n\t                    {{'tokenSms:required' | cfLabel}}\n\t                </span>\n\t\t\t\t\t<span ng-if=\"form.tokenField.$touched && form.tokenField.$error.mask\">\n\t                    {{'tokenSms:incompleteCode' | cfLabel}}\n\t                </span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"containerNovoCodigo\" ng-show=\"!$ctrl.mostraOpcoesEnvioNovoCodigo\" >\n\t\t\t\t\t<button type=\"button\"\n\t\t\t\t\t\t\tid=\"#btnNovoCodigo\"\n\t\t\t\t\t\t\tdisabled\n\t\t\t\t\t\t\ttitle=\"{{'tokenSms:generateNewCode' | cfLabel}}\"\n\t\t\t\t\t\t\tng-click=\"$ctrl.exibeOpcoesEnvioNovoCodigo()\">\n\t\t\t\t\t\t{{'tokenSms:generateNewCode' | cfLabel}}\n\t\t\t\t\t\t<span id=\"#contador\"></span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"containerOpcaoNovoCodigo\" ng-show=\"$ctrl.mostraOpcoesEnvioNovoCodigo\">\n\t\t\t\t<p class=\"titleOpcaoNovoCodigo\">{{'tokenSms:optionsGenerateNewCode' | cfLabel}}</p>\n\t\t\t\t<button class=\"btnOpcaoNovoCodigo\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\ttitle=\"{{'tokenSms:newCodeBtn2' | cfLabel}}\"\n\t\t\t\t\t\tng-show=\"!$ctrl.loadingNewCode\"\n\t\t\t\t\t\tng-click=\"$ctrl.sendNewToken('WhatsApp')\">\n\t\t\t\t\t{{'newTokenWhatsApp:newCodeBtnWhatsApp' | cfLabel}}\n\t\t\t\t</button>\n\t\t\t\t<button class=\"btnOpcaoNovoCodigo\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\ttitle=\"{{'tokenSms:newCodeBtn' | cfLabel}}\"\n\t\t\t\t\t\tng-show=\"!$ctrl.loadingNewCode\"\n\t\t\t\t\t\tng-click=\"$ctrl.sendNewToken('SMS')\">\n\t\t\t\t\t{{'newTokenSms:newCodeBtnSms' | cfLabel}}\n\t\t\t\t</button>\n\t\t\t\t<span ng-show=\"$ctrl.loadingNewCode\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n\t\t\t</div>\n\t\t\t<div class=\"linhaTop\">&nbsp;</div>\n\t\t\t<div class=\"pt-15\">\n\t\t\t\t<button type=\"submit\"\n\t\t\t\t        title=\"{{'tokenSms:validateBtnDesc' | cfLabel}}\"\n\t\t\t\t\t\tng-class=\"form.$invalid || form.$pristine || $ctrl.loading ? 'btn btn-lg corDisable btn-block':'btn btn-lg btn-cooperforte btn-block'\"\n\t\t\t\t        ng-disabled=\"form.$invalid || form.$pristine || $ctrl.loading\">\n\t\t\t\t\t<span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n\t\t\t\t\t{{'tokenSms:validateBtn' | cfLabel}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</fieldset>\n\t</form>\n</div>\n\n<div class=\"panel-footer pY-20 footer-token\">\n\t<div class=\"text-justify\">\n\t\t{{'tokenSms:footerText1' | cfLabel}}\n\t\t<strong>{{'tokenSms:footerText2' | cfLabel}}</strong>\n\t</div>\n</div>\n\n<!-- 200 token new code sucess -->\n<script type=\"text/ng-template\" id=\"newTokenNotification.modal.html\">\n\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{'newTokenSms:titleModalNewToken' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\n\t<div class=\"modal-body\">\n\t\t<p>{{$ctrl.isEnvioPorSms ? 'newTokenSms:textModalNewToken' : 'newTokenWhatsApp:textModalNewToken' | cfLabel}}</p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\">\n\t\t\t{{'newTokenSms:textBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n\n<!-- 200 Token Valid Notification Modal -->\n<script type=\"text/ng-template\" id=\"tokenValidNotification.modal.html\">\n\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{'tokenSms:titleModalTokenValid' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\n\t<div class=\"modal-body\">\n\t\t<p>{{'tokenSms:textModalTokenValid' | cfLabel}}</p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t        title=\"{{'global:continueProcessBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:continueProcessBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n\n<!-- 40X Invalid Token Notification Modal -->\n<script type=\"text/ng-template\" id=\"invalidTokenNotification.modal.html\">\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{$ctrl.code == 400 ? 'tokenSms:titleModalTokenValid' : 'global:titleModal'+$ctrl.code+'Error' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\t<div class=\"modal-body text-justify\">\n\t\t<p>{{$ctrl.code === 400 ? 'tokenSms:textModal400Error' : 'global:textModal'+$ctrl.code+'Error' | cfLabel}}</p>\n\t\t<div ng-if=\"$ctrl.code === 403\" class=\"text-center\">\n\t\t\t{{'global:labelSupportCentral' | cfLabel}}\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber' | cfLabel}}\n\t\t\t</strong>\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber2' | cfLabel}}\n\t\t\t</strong>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.code === 404\" class=\"text-center\">\n\t\t\t{{'global:textModal404InvalidInformation' | cfLabel}}\n\t\t\t<br/><br/>\n\t\t\t{{'global:labelSupportCentral' | cfLabel}}\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber' | cfLabel}}\n\t\t\t</strong>\n\t\t\t<br/>\n\t\t\t<strong>\n\t\t\t\t{{'global:centralTelephoneNumber2' | cfLabel}}\n\t\t\t</strong>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t        title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:closeBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n\n<!-- Error Notification Modal -->\n<script type=\"text/ng-template\" id=\"errorNotificationModal.modal.html\">\n\t<div class=\"modal-header\">\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t</button>\n\t\t<h5 class=\"modal-title text-center\">\n\t\t\t<strong class=\"text-uppercase\">\n\t\t\t\t{{'newTokenSms:titleErrorModal' | cfLabel}}\n\t\t\t</strong>\n\t\t</h5>\n\t</div>\n\t<div class=\"modal-body text-justify\">\n\t\t<p>{{'newTokenSms:textErrorModal' | cfLabel}}</p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n\t\t\t\ttitle=\"{{'global:closeBtnDesc' | cfLabel}}\">\n\t\t\t{{'global:closeBtn' | cfLabel}}\n\t\t</button>\n\t</div>\n</script>\n"

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(601);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(605);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Token Verification Controller
	 */
	var TokenSmsController = function () {
	    TokenSmsController.$inject = ["recoveryPasswordService", "$scope", "$uibModal", "$state"];
	    function TokenSmsController(recoveryPasswordService, $scope, $uibModal, $state) {
	        'ngInject';
	
	        //Exposing globals to another methods
	
	        (0, _classCallCheck3.default)(this, TokenSmsController);
	        this.recoveryPasswordService = recoveryPasswordService;
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	        this.loading = false;
	        this.mostraOpcoesEnvioNovoCodigo = false;
	        this.labelTipoEnvio = 'SMS';
	        this.token = "";
	        this.contador();
	        this.$scope.iniciaContagemTempo();
	    }
	
	    (0, _createClass3.default)(TokenSmsController, [{
	        key: 'contador',
	        value: function contador() {
	            function startTimer() {
	                var duracao = 30;
	                var tempo = duracao,
	                    minutos,
	                    segundos;
	                var intervalo = setInterval(function () {
	                    minutos = parseInt(tempo / 60, 10);
	                    segundos = parseInt(tempo % 60, 10);
	                    minutos = minutos < 10 ? "0" + minutos : minutes;
	                    segundos = segundos < 10 ? "0" + segundos : segundos;
	                    document.getElementById('#contador').innerHTML = " em: " + minutos + ":" + segundos;
	                    if (--tempo < 0) {
	                        tempo = duracao;
	                    }
	                    if (tempo === 0) {
	                        document.getElementById('#contador').innerHTML = "";
	                        document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo');
	                        document.getElementById('#btnNovoCodigo').removeAttribute('disabled');
	                        clearInterval(intervalo);
	                    }
	                }, 1000);
	            }
	            window.onload = function () {
	                document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
	                startTimer();
	            };
	
	            this.$scope.iniciaContagemTempo = function () {
	                document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
	                startTimer();
	            };
	
	            this.$scope.resetContador = function () {
	                document.getElementById('#btnNovoCodigo').setAttribute('disabled', '');
	                document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
	                startTimer();
	            };
	        }
	    }, {
	        key: 'exibeOpcoesEnvioNovoCodigo',
	        value: function exibeOpcoesEnvioNovoCodigo() {
	            this.mostraOpcoesEnvioNovoCodigo = !this.mostraOpcoesEnvioNovoCodigo;
	        }
	    }, {
	        key: 'sendNewToken',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(tipoEnvio) {
	                var processId, result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.loadingNewCode = true;
	                                processId = sessionStorage.getItem("idProcesso");
	
	
	                                this.labelTipoEnvio = tipoEnvio;
	                                result = void 0;
	
	                                if (!(tipoEnvio === 'SMS')) {
	                                    _context.next = 10;
	                                    break;
	                                }
	
	                                _context.next = 7;
	                                return this.recoveryPasswordService.sendNewSmsToken(processId).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 7:
	                                result = _context.sent;
	                                _context.next = 13;
	                                break;
	
	                            case 10:
	                                _context.next = 12;
	                                return this.recoveryPasswordService.sendNewWhatsAppToken(processId).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 12:
	                                result = _context.sent;
	
	                            case 13:
	
	                                if (result.status === 200) {
	                                    this.newTokenNotification(tipoEnvio);
	                                } else {
	                                    this.showErrorModal();
	                                }
	                                this.loadingNewCode = false;
	                                this.$scope.$apply();
	
	                            case 16:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function sendNewToken(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return sendNewToken;
	        }()
	    }, {
	        key: 'confirmVerificationToken',
	        value: function () {
	            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	                var result;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (!this.$scope.form.$invalid) {
	                                    _context2.next = 2;
	                                    break;
	                                }
	
	                                return _context2.abrupt('return');
	
	                            case 2:
	
	                                this.loading = true;
	
	                                result = void 0;
	                                _context2.next = 6;
	                                return this.recoveryPasswordService.confirmSmsToken(this.token).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 6:
	                                result = _context2.sent;
	
	                                if (!(result.status === 200)) {
	                                    _context2.next = 14;
	                                    break;
	                                }
	
	                                _context2.next = 10;
	                                return this.recoveryPasswordService.retrieveSecurityQuestions().catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 10:
	                                result = _context2.sent;
	
	                                if (result.status === 200) {
	                                    this.showValidTokenModal(result.data);
	                                } else {
	                                    this.showInvalidTokenModal(result.status);
	                                }
	                                _context2.next = 15;
	                                break;
	
	                            case 14:
	                                if ([400, 401, 403].contains(result.status)) this.showInvalidTokenModal(result.status);
	
	                            case 15:
	                                this.loading = false;
	                                this.$scope.$apply();
	
	                            case 17:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function confirmVerificationToken() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return confirmVerificationToken;
	        }()
	
	        /**
	         * 200 - new token notification
	         */
	
	    }, {
	        key: 'newTokenNotification',
	        value: function newTokenNotification(tipoEnvio) {
	            var _this = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'newTokenNotification.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", function controller($scope) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.isEnvioPorSms = tipoEnvio === "SMS";
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                        _this.mostraOpcoesEnvioNovoCodigo = !_this.mostraOpcoesEnvioNovoCodigo;
	                        _this.$scope.resetContador();
	                    };
	                }]
	            });
	        }
	    }, {
	        key: 'showValidTokenModal',
	
	
	        /**
	         * 200 - Process Started Notification Modal
	         */
	        value: function showValidTokenModal(securityQuestions) {
	            var _this2 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'tokenValidNotification.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", function controller($scope) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }]
	            });
	            modalInstance.result.then(function () {
	                _this2.$state.go('question', { securityQuestions: securityQuestions });
	            });
	        }
	    }, {
	        key: 'showInvalidTokenModal',
	
	
	        /**
	         * 40X - Error Notification Modal
	         */
	        value: function showInvalidTokenModal(_code) {
	            var _this3 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'invalidTokenNotification.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", "code", function controller($scope, code) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.code = code;
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    code: function code() {
	                        return _code;
	                    }
	                }
	            });
	
	            modalInstance.result.then(function () {
	                if (_code > 400) _this3.$state.go("login");
	            }, function () {
	                if (_code > 403) _this3.$state.go("login");
	            });
	        }
	    }, {
	        key: 'showErrorModal',
	
	
	        /**
	         * Error Notification Modal
	         */
	        value: function showErrorModal() {
	            var _this4 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'errorNotificationModal.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", function controller($scope) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                        _this4.mostraOpcoesEnvioNovoCodigo = !_this4.mostraOpcoesEnvioNovoCodigo;
	                        _this4.$scope.resetContador();
	                    };
	                }]
	            });
	        }
	    }]);
	    return TokenSmsController;
	}();
	
	exports.default = TokenSmsController;

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(780);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tokenSms.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tokenSms.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "token{width:100%;height:100%}.footer-token{font-size:12px}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.containerNovoCodigo{display:flex;flex-direction:row;font-size:12px}.btnNovoCodigo{background-color:#fff;border:none;margin:0 auto;text-decoration:underline;font-weight:700;color:#000}.btnNovoCodigoDisabled{font-weight:500;text-decoration:none;color:grey}.containerOpcaoNovoCodigo{display:flex;flex-direction:column;align-items:center;margin-bottom:10px}.titleOpcaoNovoCodigo{font-size:12px;font-weight:600;text-align:center;margin:0 auto}.btnOpcaoNovoCodigo{margin:8px;width:100%;padding:8px;background-color:#fdcf00;border:1px solid #bfbfbf;border-radius:6px}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}.texto-reenvio-codigo{font-size:12px;text-align:center}", ""]);
	
	// exports


/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _questionTemplate = __webpack_require__(782);
	
	var _questionTemplate2 = _interopRequireDefault(_questionTemplate);
	
	var _question = __webpack_require__(783);
	
	var _question2 = _interopRequireDefault(_question);
	
	__webpack_require__(784);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Question Verification View Module
	 */
	exports.default = _angular2.default.module('question', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $stateProvider.state('question', {
	        url: '/pergunta-seguranca',
	        component: 'question',
	        params: { securityQuestions: null }
	    });
	}]).component('question', {
	    bindings: {},
	    template: _questionTemplate2.default,
	    controller: _question2.default
	}).name;

/***/ }),

/***/ 782:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10\">\n    <form class=\"col-sm-12\" id=\"form\" name=\"form\" novalidate ng-submit=\"$ctrl.checkAnsweredSecurityQuestions()\">\n        <p class=\"welcome-texts\">\n        <p class=\"texto-passo\">Passo 3 de 4</p>\n            {{'question:welcomeText' | cfLabel}}\n        </p>\n        <p class=\"welcome-texts\">\n            {{$ctrl.questionQualifier}}{{$ctrl.question.description}}\n        </p>\n        <div class=\"pt-15\" ng-repeat=\"a in $ctrl.question.possibleAnswers\">\n            <span style=\"white-space: normal;font-size: 1.2em;\"\n                  ng-click=\"($ctrl.question.selectedAnswer = a)\"\n                  ng-class=\"$ctrl.question.selectedAnswer.description === a.description ? 'btn btn-lg btn-clicked btn-block':'btn btn-lg corCinzaClaro btn-block'\"\n                  >\n                {{a.description}}\n            </span>\n        </div>\n        <div ng-if=\"!$ctrl.question.possibleAnswers || $ctrl.question.possibleAnswers.length == 0\">\n            <label for=\"inputedAnswer\">Informe a resposta</label>\n            <input\n                    id=\"inputedAnswer\"\n                    name=\"inputedAnswer\"\n                    ex-autofocus\n                    required\n                    class=\"form-control\"\n                    type=\"text\"\n                    ng-model=\"$ctrl.question.selectedAnswer.description\">\n        </div>\n        <div class=\"linhaBottom\">&nbsp;</div>\n        <div class=\"pt-15 question\">\n            <button type=\"submit\"\n                    title=\"{{'question:sendBtnDesc' | cfLabel}}\"\n                    ng-class=\"$ctrl.question.selectedAnswer.description === null || $ctrl.loading ? 'btn btn-lg corDisable btn-block':'btn btn-lg btn-cooperforte btn-block'\"\n                    ng-disabled=\"$ctrl.question.selectedAnswer.description === null || $ctrl.loading\">\n                <span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n                {{'question:sendBtn' | cfLabel}}\n            </button>\n        </div>\n    </form>\n</div>\n\n<div class=\"panel-footer pY-20 footer-question\">\n    <div class=\"text-center\">\n        {{'question:footerText1' | cfLabel}}<br/>\n        {{'question:footerText2' | cfLabel}} <strong>{{'global:centralTelephoneNumber' | cfLabel}}</strong>\n    </div>\n</div>\n<!-- 40X Invalid Answers Notification Modal -->\n<script type=\"text/ng-template\" id=\"invalidAnswers.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{$ctrl.code == 400 ? 'question:titleModal400Error' : 'global:titleModal'+$ctrl.code+'Error' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body text-justify\">\n        <p>{{$ctrl.code === 400 ? 'token:textModal400Error' : 'global:textModal'+$ctrl.code+'Error'| cfLabel}}</p>\n        <div ng-if=\"$ctrl.code === 403\" class=\"text-center\">\n            {{'global:labelSupportCentral' | cfLabel}}\n            <br/>\n            <strong>\n                {{'global:centralTelephoneNumber' | cfLabel}}\n            </strong><br>\n            <strong>\n                {{'global:centralTelephoneNumber2' | cfLabel}}\n            </strong>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n                title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n            {{'global:closeBtn' | cfLabel}}\n        </button>\n    </div>\n</script>"

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(601);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(605);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Question Controller
	 */
	var QuestionController = function () {
	    QuestionController.$inject = ["recoveryPasswordService", "$scope", "$uibModal", "$state", "$stateParams"];
	    function QuestionController(recoveryPasswordService, $scope, $uibModal, $state, $stateParams) {
	        'ngInject';
	        //Exposing globals to another methods
	
	        (0, _classCallCheck3.default)(this, QuestionController);
	        this.recoveryPasswordService = recoveryPasswordService;
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	        this.securityQuestions = angular.copy($stateParams.securityQuestions);
	        this.question = {};
	        this.questionQualifier = null;
	        if (this.securityQuestions) {
	            this.configureQuestionQualifier();
	            this.selectRandomQuestion();
	        }
	        this.loading = false;
	        if (!this.question.possibleAnswers || this.question.possibleAnswers.length == 0) {
	            this.$state.go('token');
	        }
	    }
	
	    (0, _createClass3.default)(QuestionController, [{
	        key: 'configureQuestionQualifier',
	        value: function configureQuestionQualifier() {
	            var count = this.securityQuestions.questions.filter(function (q) {
	                return q.selectedAnswer !== null;
	            }).length + 1;
	            this.questionQualifier = count + ' - ';
	        }
	    }, {
	        key: 'selectRandomQuestion',
	        value: function selectRandomQuestion() {
	            var showIdentityQuestion = sessionStorage.getItem('showIdentityQuestion');
	            var unansweredQuestions = this.securityQuestions.questions.filter(function (q) {
	                return q.selectedAnswer === null;
	            });
	
	            if (!showIdentityQuestion) {
	                var indexOfIdentityQuestion = 1;
	                unansweredQuestions.splice(indexOfIdentityQuestion, 1);
	                sessionStorage.setItem('showIdentityQuestion', true);
	            }
	
	            var length = unansweredQuestions.length;
	            this.question = unansweredQuestions[new Date().getTime() % length];
	
	            var answeredQuestions = this.securityQuestions.questions.filter(function (q) {
	                return q.selectedAnswer !== null;
	            });
	
	            if (length > 2) {
	                angular.forEach(answeredQuestions, function (val, key) {
	                    if ((val.type === 'BANK_AGENCY_NUMBER' || val.type === 'BANK_ACCOUNT_NUMBER') && (this.question.type === 'BANK_AGENCY_NUMBER' || this.question.type === 'BANK_ACCOUNT_NUMBER')) {
	                        this.question = unansweredQuestions[new Date().getTime() % (length - 1)];
	                    }
	                }, this);
	            }
	
	            if (!this.question.selectedAnswer) this.question.selectedAnswer = { description: null };
	        }
	    }, {
	        key: 'checkAnsweredSecurityQuestions',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	                var count, result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.loading = true;
	                                count = this.securityQuestions.questions.filter(function (q) {
	                                    return q.selectedAnswer !== null;
	                                }).length;
	                                result = void 0;
	                                _context.next = 5;
	                                return this.recoveryPasswordService.checkAnsweredSecurityQuestion(this.securityQuestions).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 5:
	                                result = _context.sent;
	
	                                if (count === 1) {
	                                    if (result.status === 200) {
	                                        this.$state.go('question', { securityQuestions: this.securityQuestions });
	                                    } else if ([400, 401, 403].contains(result.status)) {
	                                        this.showAnswersModal(result.status);
	                                    }
	                                } else {
	                                    if (result.status === 200) {
	                                        this.$state.go("password");
	                                    } else if ([400, 401, 403].contains(result.status)) {
	                                        this.showAnswersModal(result.status);
	                                    }
	                                    this.$scope.$apply();
	                                }
	                                this.loading = false;
	
	                            case 8:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function checkAnsweredSecurityQuestions() {
	                return _ref.apply(this, arguments);
	            }
	
	            return checkAnsweredSecurityQuestions;
	        }()
	    }, {
	        key: 'sendToServer',
	        value: function () {
	            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	                var result;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                result = void 0;
	                                _context2.next = 3;
	                                return this.recoveryPasswordService.checkAnsweredSecurityQuestion(this.securityQuestions).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 3:
	                                result = _context2.sent;
	
	                                if (result.status === 200) {
	                                    this.$state.go("password");
	                                } else if ([400, 401, 403].contains(result.status)) this.showAnswersModal(result.status);
	                                this.loading = false;
	                                this.$scope.$apply();
	
	                            case 7:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function sendToServer() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return sendToServer;
	        }()
	
	        /**
	         * 40X - Error Notification Modal
	         */
	
	    }, {
	        key: 'showAnswersModal',
	        value: function showAnswersModal(_code) {
	            var _this = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'invalidAnswers.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", "code", function controller($scope, code) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.code = code;
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    code: function code() {
	                        return _code;
	                    }
	                }
	            });
	
	            modalInstance.result.then(function () {
	                if (_code > 400) _this.$state.go("login");
	            }, function () {
	                if (_code > 403) _this.$state.go("login");
	            });
	        }
	    }]);
	    return QuestionController;
	}();
	
	exports.default = QuestionController;

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(785);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./question.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./question.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, ".btn-clicked{background-color:#bfbfbf!important}.btn-selection{color:#000;-webkit-text-shadow:0 -1px 0 rgba(0,0,0,.25);text-shadow:0 -1px 0 rgba(0,0,0,.25);background-color:#fdf8d1;text-transform:uppercase}.footer-question{font-size:12px}.corCinzaClaro{background-color:#efefef;border:1px solid #ddd}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.question .btn-block{padding:10px}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}", ""]);
	
	// exports


/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _passwordTemplate = __webpack_require__(787);
	
	var _passwordTemplate2 = _interopRequireDefault(_passwordTemplate);
	
	var _password = __webpack_require__(788);
	
	var _password2 = _interopRequireDefault(_password);
	
	__webpack_require__(791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Question Verification View Module
	 */
	exports.default = _angular2.default.module('password', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $stateProvider.state('password', {
	        url: '/alterar-senha',
	        component: 'password'
	    });
	}]).component('password', {
	    bindings: {},
	    template: _passwordTemplate2.default,
	    controller: _password2.default
	}).name;

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10 pt-15\">\n    <form class=\"col-sm-12\" id=\"form\" name=\"form\" novalidate ng-submit=\"$ctrl.changePassword()\">\n\n        <fieldset class=\"pt-5\">\n            <div class=\"form-group\"\n                 ng-class=\"{'has-error' : form.newPassword.$touched && (form.newPassword.$error | json) !== '{}'}\">\n                <p class=\"texto-passo\">Passo 4 de 4</p>\n                <label for=\"newPassword\">\n                    {{'password:newPasswordField' | cfLabel}}\n                </label>\n                <div class=\"passwordFieldBlock\">\n                    <input id=\"newPassword\"\n                           tabindex=\"1\"\n                           name=\"newPassword\"\n                           ex-autofocus\n                           class=\"form-control\"\n                           type={{$ctrl.passwordFieldType}}\n                           maxlength=\"20\"\n                           inputmode=\"text\"\n                           ng-model=\"$ctrl.passwordChange.newPassword\"\n                           ng-change=\"$ctrl.validatePasswordField(form.newPassword.$viewValue)\"\n                           ng-disabled=\"$ctrl.loading\"\n                           required>\n                    <span style=\"margin: 10px\"\n                          ng-class=\"{'glyphicon glyphicon-eye-close': $ctrl.showPasswordField, 'glyphicon glyphicon-eye-open': !$ctrl.showPasswordField }\"\n                          ng-click=\"$ctrl.showPasswordContent($ctrl.showPasswordField)\"\n                    />\n                </div>\n\n                <div class=\"help-block\">\n\t                <span ng-if=\"form.newPassword.$touched && form.newPassword.$error.required\">\n\t                    {{'global:required' | cfLabel}}\n\t                </span>\n                    <span ng-if=\"form.newPassword.$touched && (form.newPassword.$error.minlength || form.newPassword.$error.pattern)\">\n\t                    {{'password:invalidPassword' | cfLabel}}\n\t                </span>\n                </div>\n            </div>\n\n            <div class=\"form-group\"\n                 ng-class=\"{'has-error' : form.repeatPassword.$touched && (form.repeatPassword.$error | json) !== '{}'}\">\n                <label for=\"repeatPassword\">\n                    {{'password:repeatPasswordField' | cfLabel}}\n                </label>\n                <div class=\"passwordFieldBlock\">\n                <input id=\"repeatPassword\"\n                       tabindex=\"2\"\n                       name=\"repeatPassword\"\n                       class=\"form-control\"\n                       type={{$ctrl.repeatPasswordFieldType}}\n                       maxlength=\"20\"\n                       minlength=\"8\"\n                       inputmode=\"text\"\n                       password-match=\"newPassword\"\n                       ng-model=\"$ctrl.passwordChange.passwordRepeat\"\n                       ng-disabled=\"$ctrl.loading\"\n                       required/>\n                    <span style=\"margin: 10px\"\n                          ng-class=\"{'glyphicon glyphicon-eye-close': $ctrl.showRepeatPasswordField, 'glyphicon glyphicon-eye-open': !$ctrl.showRepeatPasswordField }\"\n                          ng-click=\"$ctrl.showRepeatPasswordContent($ctrl.showRepeatPasswordField)\"\n                    />\n                </div>\n\n                <div class=\"help-block\">\n\t                <span ng-if=\"form.repeatPassword.$touched && form.repeatPassword.$error.required\">\n\t                    {{'global:required' | cfLabel}}\n\t                </span>\n                    <span ng-if=\"form.newPassword.$touched && (form.newPassword.$error.minlength || form.newPassword.$error.pattern)\">\n\t                    {{'password:invalidPassword' | cfLabel}}\n\t                </span>\n                    <span ng-if=\"form.repeatPassword.$touched &&\n                    !form.repeatPassword.$error.minlength &&\n                    form.repeatPassword.$error.passwordMatch\">\n\t                    {{'password:matchError' | cfLabel}}\n\t                </span>\n                </div>\n            </div>\n\n            <!--Controle validação senha-->\n\n            <div class=\"help-block\">\n                <p class=\"validationTitle\">\n                    {{'password:passwordLength' | cfLabel}}\n                </p>\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"!$ctrl.haveNumber\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"$ctrl.haveNumber\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:haveOneNumber' | cfLabel}}\n                    </p>\n                </span>\n\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"!$ctrl.haveUppercase\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"$ctrl.haveUppercase\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:haveUppercaseCaracter' | cfLabel}}\n                    </p>\n                </span>\n\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"!$ctrl.haveLowercase\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"$ctrl.haveLowercase\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:haveLowercaseCaracter' | cfLabel}}\n                    </p>\n                </span>\n\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"!$ctrl.haveSpecialCaracter\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"$ctrl.haveSpecialCaracter\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:haveSpecialCaracter' | cfLabel}}\n                    </p>\n                </span>\n\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"!$ctrl.haveMinimumEightCaracters\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"$ctrl.haveMinimumEightCaracters\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:passwordHaveMinimumEightCaracters' | cfLabel}}\n                    </p>\n                </span>\n\n                <span class=\"validationBlock\">\n                    <p class=\"circleNoValidate\" ng-if=\"form.$invalid\">\n                        <i class=\"glyphicon glyphicon-remove-circle\"></i>\n                    </p>\n                    <p class=\"circleValidate\" ng-if=\"!form.$invalid\">\n                        <i class=\"glyphicon glyphicon-ok-circle\"></i>\n                    </p>\n                    <p class=\"validateType\">\n                        {{'password:passwordsMatch' | cfLabel}}\n                    </p>\n                </span>\n\n            </div>\n            <div class=\"panel-footer pY-20 footer-token\">\n                <div class=\"text-center\">\n                    {{'password:footerText3' | cfLabel}}<br/>\n                </div>\n            </div>\n            <div class=\"linhaTop\">&nbsp;</div>\n            <div>\n                <button type=\"submit\"\n                        title=\"{{'password:changeBtnDesc' | cfLabel}}\"\n                        ng-class=\"form.$invalid || form.$pristine || $ctrl.loading || $ctrl.disabledButton ? 'btn btn-lg corCinzaClaro btn-block':'btn btn-lg btn-cooperforte btn-block'\"\n                        ng-disabled=\"form.$invalid || form.$pristine || $ctrl.loading || $ctrl.disabledButton\">\n                    <span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n                    {{'password:changeBtn' | cfLabel}}\n                </button>\n            </div>\n        </fieldset>\n    </form>\n\n</div>\n\n<!-- 40X Password change error -->\n<script type=\"text/ng-template\" id=\"passwordErrorModal.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{$ctrl.code == 400 ? 'password:titleModal400Error' : 'global:titleModal'+$ctrl.code+'Error' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body text-justify\">\n\n        <div ng-if=\"$ctrl.code === 403 || $ctrl.code === 400 || $ctrl.code === 401\" class=\"text-center\">\n            {{'global:labelSupportCentral' | cfLabel}}\n            <br/>\n            <strong>\n                {{'global:centralTelephoneNumber' | cfLabel}}\n            </strong>\n            <br/>\n            <strong>\n                {{'global:centralTelephoneNumber2' | cfLabel}}\n            </strong>\n        </div>\n        <div ng-if=\"$ctrl.code === 409\" class=\"text-center\">\n            {{'password:titleModal409InvalidPassword' | cfLabel}}\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-lg btn-cooperforte btn-block\" type=\"button\" ng-click=\"$ctrl.ok()\"\n                title=\"{{'global:closeBtnDesc' | cfLabel}}\">\n            {{'global:closeBtn' | cfLabel}}\n        </button>\n    </div>\n</script>\n\n<!-- Password changed modal -->\n<script type=\"text/ng-template\" id=\"passwordChangedModal.modal.html\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.ok()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n\n        <h5 class=\"modal-title text-center\">\n            <strong class=\"text-uppercase\">\n                {{'password:titleModalSenha' | cfLabel}}\n            </strong>\n        </h5>\n    </div>\n    <div class=\"modal-body text-justify\">\n        <div class=\"text-center\">\n            <p>{{'password:passwordChangedText' | cfLabel}}</p>\n            <p>{{'password:passwordChangedText2' | cfLabel}}</p>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" ng-click=\"$ctrl.ok()\">\n            <p class=\"link\">Acessar </p>\n        </button>\n    </div>\n</script>"

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(789);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(601);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(605);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Password change Controller
	 */
	var PasswordController = function () {
	    PasswordController.$inject = ["recoveryPasswordService", "$scope", "$uibModal", "$state", "$window", "$location"];
	    function PasswordController(recoveryPasswordService, $scope, $uibModal, $state, $window, $location) {
	        'ngInject';
	        //Exposing globals to another methods
	
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, PasswordController);
	
	        this.validatePasswordField = function (text) {
	            var HAVE_NUMBER_REGEX = /[0-9]/;
	            var HAVE_UPPERCASE_REGEX = /[A-Z]/;
	            var HAVE_LOWERCASE_REGEX = /[a-z]/;
	            var HAVE_SPECIAL_CARACTER = /[$*&@%#!?.,:;/_+=-]/;
	
	            _this.haveNumber = HAVE_NUMBER_REGEX.test(text);
	            _this.haveUppercase = HAVE_UPPERCASE_REGEX.test(text);
	            _this.haveLowercase = HAVE_LOWERCASE_REGEX.test(text);
	            _this.haveSpecialCaracter = HAVE_SPECIAL_CARACTER.test(text);
	            _this.haveMinimumEightCaracters = text.length >= 8;
	
	            if (_this.haveNumber && _this.haveUppercase && _this.haveLowercase && _this.haveSpecialCaracter && _this.haveMinimumEightCaracters) {
	                _this.disabledButton = false;
	            }
	        };
	
	        this.showPasswordContent = function (disable) {
	
	            if (disable) {
	                _this.showPasswordField = false;
	                _this.passwordFieldType = "password";
	            } else {
	                _this.showPasswordField = true;
	                _this.passwordFieldType = "text";
	            }
	        };
	
	        this.showRepeatPasswordContent = function (disable) {
	
	            if (disable) {
	                _this.showRepeatPasswordField = false;
	                _this.repeatPasswordFieldType = "password";
	            } else {
	                _this.showRepeatPasswordField = true;
	                _this.repeatPasswordFieldType = "text";
	            }
	        };
	
	        this.verificaSeDispositivoMobile = function () {
	            if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	                return true;
	            } else {
	                return false;
	            }
	        };
	
	        this.recoveryPasswordService = recoveryPasswordService;
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	        this.loading = false;
	        this.passwordChange = { newPassword: null, passwordRepeat: null };
	        this.haveNumber = false;
	        this.haveUppercase = false;
	        this.haveLowercase = false;
	        this.haveSpecialCaracter = false;
	        this.haveMinimumEightCaracters = false;
	        this.showPasswordField = false;
	        this.passwordFieldType = "password";
	        this.showRepeatPasswordField = false;
	        this.repeatPasswordFieldType = "password";
	        this.disabledButton = true;
	        this.$window = $window;
	        this.$location = $location;
	    }
	
	    (0, _createClass3.default)(PasswordController, [{
	        key: "changePassword",
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	                var result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.loading = true;
	
	                                result = void 0;
	                                _context.next = 4;
	                                return this.recoveryPasswordService.changePassword(this.passwordChange).catch(function (e) {
	                                    return result = e;
	                                });
	
	                            case 4:
	                                result = _context.sent;
	
	
	                                if (result.status === 200) {
	                                    this.showPasswordChangedModal(result.data.email);
	                                } else if ([400, 401, 403, 409].contains(result.status)) this.showErrorModal(result.status);
	                                this.loading = false;
	                                this.$scope.$apply();
	
	                            case 8:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function changePassword() {
	                return _ref.apply(this, arguments);
	            }
	
	            return changePassword;
	        }()
	    }, {
	        key: "showPasswordChangedModal",
	        value: function showPasswordChangedModal(_email) {
	            var _this2 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'passwordChangedModal.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", "email", function controller($scope, email) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.email = email;
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    email: function email() {
	                        return _email;
	                    }
	                }
	
	            });
	
	            modalInstance.result.then(function () {
	                _this2.navigateToSite();
	            });
	        }
	    }, {
	        key: "navigateToSite",
	        value: function navigateToSite() {
	            this.isDispositivoMobile = this.verificaSeDispositivoMobile();
	
	            if (this.isDispositivoMobile) {
	                var s = (0, _stringify2.default)({ fecharModal: true });
	                if (window.ReactNativeWebView) {
	                    window.ReactNativeWebView.postMessage(s);
	                } else {
	                    window.postMessage(s, '*');
	                }
	            } else {
	                var currentUrl = this.$location.absUrl().split('?')[0];
	                var destinationUrl = this.checkEnviromnetByUrl(currentUrl);
	                this.$window.location.href = destinationUrl;
	            }
	        }
	    }, {
	        key: "checkEnviromnetByUrl",
	        value: function checkEnviromnetByUrl(currentUrl) {
	            var destinationUrl = void 0;
	            if (currentUrl.includes('dev') || currentUrl.includes('desen')) destinationUrl = 'http://autoatendimento.cloud.dev.cooperforte.coop/';else if (currentUrl.includes('homol') || currentUrl.includes('hmg')) destinationUrl = 'http://autoatendimento.cloud.homol.cooperforte.coop/';else if (currentUrl.includes('eleicoes')) destinationUrl = 'https://eleicoes2021-homol.cf.coop.br/inscricao/';else destinationUrl = 'https://autoatendimento.cf.coop.br/';
	
	            return destinationUrl;
	        }
	    }, {
	        key: "showErrorModal",
	        value: function showErrorModal(_code) {
	            var _this3 = this;
	
	            var modalInstance = this.$uibModal.open({
	                animation: true,
	                templateUrl: 'passwordErrorModal.modal.html',
	                controllerAs: '$ctrl',
	                size: 'sm',
	                controller: ["$scope", "code", function controller($scope, code) {
	                    "ngInject";
	
	                    var $ctrl = $scope.$ctrl;
	
	                    $ctrl.code = code;
	                    $ctrl.ok = function () {
	                        modalInstance.close();
	                    };
	                }],
	                resolve: {
	                    code: function code() {
	                        return _code;
	                    }
	                }
	            });
	
	            modalInstance.result.then(function () {
	                if (_code > 400 && _code != 409) _this3.$state.go("login");
	            }, function () {
	                if (_code > 403 && _code != 409) _this3.$state.go("login");
	            });
	        }
	    }]);
	    return PasswordController;
	}();
	
	exports.default = PasswordController;

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(792);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./password.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./password.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, ".footer-question{font-size:12px}.corCinzaClaro{background-color:#efefef;border:1px solid #ddd}.validationTitle{margin-bottom:10%}.validationBlock{display:flex;flex:1;flex-direction:row;margin:auto;font-size:12px}.validateType{margin-left:2%}.circleNoValidate{color:red;font-size:16px}.circleValidate{color:green;font-size:16px}.passwordFieldBlock{display:flex;flex-direction:row;align-content:space-between}.link{color:#0277bd;font-weight:700;text-align:right;margin:5px}.link,.texto-passo{text-transform:uppercase}.texto-passo{color:#a9a4a4;text-align:center}", ""]);
	
	// exports


/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _successTemplate = __webpack_require__(794);
	
	var _successTemplate2 = _interopRequireDefault(_successTemplate);
	
	var _success = __webpack_require__(795);
	
	var _success2 = _interopRequireDefault(_success);
	
	__webpack_require__(796);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Token Verification View Module
	 */
	exports.default = _angular2.default.module('success', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('success', {
			url: '/senha-alterada',
			component: 'success',
			params: { email: null }
		});
	}]).component('success', {
		bindings: {},
		template: _successTemplate2.default,
		controller: _success2.default
	}).name;

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10\">\n    <form class=\"col-sm-12\" id=\"form\" name=\"form\">\n        <p class=\"text-center\">\n            <b>{{'success:welcomeText3' | cfLabel}}</b>\n        </p>\n        <p class=\"text-center\">\n            {{'success:mainText' | cfLabel}}\n        </p>\n        <p class=\"text-center\">\n            {{'success:mainText2' | cfLabel}}\n        </p>\n        <div class=\"linhaBottom\">&nbsp;</div>\n        <div>\n            <button type=\"button\"\n                    ng-click=\"$ctrl.navigateToSite()\"\n                    title=\"{{'success:navigateToBtnDesc' | cfLabel}}\"\n                    class=\"btn btn-lg btn-cooperforte btn-block\">\n                <span ng-show=\"$ctrl.loading\" class=\"fa fa-spinner fa-pulse fa-fw\"></span>\n                {{'success:navigateToBtn' | cfLabel}}\n            </button>\n        </div>\n    </form>\n</div>"

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(789);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(628);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Success Page Controller
	 */
	var SuccessController = function () {
	    SuccessController.$inject = ["$scope", "$uibModal", "$state", "$stateParams", "$window", "$location"];
	    function SuccessController($scope, $uibModal, $state, $stateParams, $window, $location) {
	        'ngInject';
	
	        //Exposing globals to another methods
	
	        (0, _classCallCheck3.default)(this, SuccessController);
	
	        this.verificaSeDispositivoMobile = function () {
	            if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	                return true;
	            } else {
	                return false;
	            }
	        };
	
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	
	        this.loading = false;
	        this.email = $stateParams.email;
	        this.isDispositivoMobile = false;
	    }
	
	    (0, _createClass3.default)(SuccessController, [{
	        key: 'navigateToSite',
	        value: function navigateToSite() {
	            this.isDispositivoMobile = this.verificaSeDispositivoMobile();
	
	            if (this.isDispositivoMobile) {
	                var s = (0, _stringify2.default)({ fecharModal: true });
	                if (window.ReactNativeWebView) {
	                    window.ReactNativeWebView.postMessage(s);
	                } else {
	                    window.postMessage(s, '*');
	                }
	            } else {
	                var currentUrl = this.$location.absUrl().split('?')[0];
	                var destinationUrl = this.checkEnviromnetByUrl(currentUrl);
	                this.$window.location.href = destinationUrl;
	            }
	        }
	    }, {
	        key: 'checkEnviromnetByUrl',
	        value: function checkEnviromnetByUrl(currentUrl) {
	            var destinationUrl = void 0;
	            if (currentUrl.includes('dev') || currentUrl.includes('desen')) destinationUrl = 'http://autoatendimento.cloud.dev.cooperforte.coop/';else if (currentUrl.includes('homol') || currentUrl.includes('hmg')) destinationUrl = 'http://autoatendimento.cloud.homol.cooperforte.coop/';else if (currentUrl.includes('eleicoes')) destinationUrl = 'https://eleicoes2021-homol.cf.coop.br/inscricao/';else destinationUrl = 'https://autoatendimento.cf.coop.br/';
	
	            return destinationUrl;
	        }
	    }]);
	    return SuccessController;
	}();
	
	exports.default = SuccessController;

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(797);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./success.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./success.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(336);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _blockpasswordTemplate = __webpack_require__(799);
	
	var _blockpasswordTemplate2 = _interopRequireDefault(_blockpasswordTemplate);
	
	var _blockpassword = __webpack_require__(800);
	
	var _blockpassword2 = _interopRequireDefault(_blockpassword);
	
	__webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Block Email Verification View Module
	 */
	exports.default = _angular2.default.module('blockpassword', [_angularjs2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('blockpassword', {
			url: '/blockpassword/:token/:idPessoa/:finalizouProcesso',
			component: 'blockpassword'
		});
	}]).component('blockpassword', {
		bindings: {},
		template: _blockpasswordTemplate2.default,
		controller: _blockpassword2.default
	}).name;

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-body pX-10\">\n    <form class=\"col-sm-12\" id=\"form\" name=\"form\">\n        <p class=\"text-center\">\n            {{message}}\n        </p>\n    </form>\n</div>\n"

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Block password Verification Controller
	 */
	var BlockpasswordController = function BlockpasswordController(recoveryPasswordService, $scope, $uibModal, $state, $stateParams) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, BlockpasswordController);
	    this.recoveryPasswordService = recoveryPasswordService;
	    $scope.message = '';
	
	    var result = void 0;
	    var blockPasswordObj = {
	        token: $stateParams.token,
	        idPessoa: $stateParams.idPessoa,
	        finalizouProcesso: $stateParams.finalizouProcesso
	    };
	
	    this.recoveryPasswordService.blockPassword(blockPasswordObj).then(function (e) {
	        result = e;
	        if (result.status == 200) {
	            $scope.$apply(function () {
	                $scope.message = "Sua senha foi bloqueada com sucesso!";
	            });
	        } else {
	            $scope.$apply(function () {
	                $scope.message = "Senha expirada!";
	            });
	        }
	    }).catch(function (error) {
	        $scope.$apply(function () {
	            $scope.message = "Senha expirada!";
	        });
	    });
	};
	BlockpasswordController.$inject = ["recoveryPasswordService", "$scope", "$uibModal", "$state", "$stateParams"];
	
	exports.default = BlockpasswordController;

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(802);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./blockpassword.style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./blockpassword.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "blockpassword{width:100%;height:100%}.footer-blockpassword{font-size:12px}", ""]);
	
	// exports


/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(438);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _general = __webpack_require__(804);
	
	var _general2 = _interopRequireDefault(_general);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Module definition for simple general purpose filters
	 */
	var filters = _angular2.default.module('app.filters', []);
	
	(0, _keys2.default)(_general2.default).forEach(function (key) {
	  filters.filter(key, _general2.default[key]);
	});
	
	exports.default = filters.name;

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(474);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * General purpose simple filters - Functions definition
	 */
	
	/**
	 * Brazilian CPF number filter
	 */
	var cpf = function cpf() {
	  return function (input) {
	    if (!_utils2.default.isEmpty(input)) return input.mask('000.000.000-00');
	
	    return "";
	  };
	};
	
	/**
	 * Show a '-' when filtered value is empty
	 */
	var dash = function dash() {
	  return function (input) {
	    return !_utils2.default.isEmpty(input) ? input : "-";
	  };
	};
	
	/**
	 * Resolve labels from Cooperforte WordPress label service
	 * @ngInject
	 */
	var cfLabel = function cfLabel(labelService) {
	  return function (input) {
	    return !_utils2.default.isEmpty(input) ? labelService.getLabelByExpression(input) : "";
	  };
	};
	cfLabel.$inject = ["labelService"];
	
	exports.default = {
	  cpf: cpf,
	  dash: dash,
	  cfLabel: cfLabel
	};

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(789);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _restangular = __webpack_require__(806);
	
	var _restangular2 = _interopRequireDefault(_restangular);
	
	var _recoveryPassword = __webpack_require__(808);
	
	var _recoveryPassword2 = _interopRequireDefault(_recoveryPassword);
	
	var _label = __webpack_require__(809);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Services definition
	 */
	
	var services = _angular2.default.module('app.services', ['restangular']);
	
	services.factory("labelService", _label2.default);
	services.factory("recoveryPasswordService", _recoveryPassword2.default);
	
	/*
	 * Providers configuration stage
	 */
	services.config(["RestangularProvider", function (RestangularProvider) {
		RestangularProvider.setBaseUrl( false ? 'http://apphmg/senhaop/rest/' : '/senhaop/rest/');
	
		RestangularProvider.setFullResponse(true);
		RestangularProvider.setDefaultHttpFields({ timeout: -1 });
		RestangularProvider.setDefaultHeaders({ 'Content-Type': 'application/json' });
	
		window.addEventListener("message", function (message) {
			try {
				var deviceInfos = JSON.parse(message.data);
				if (deviceInfos.platform === 'ios' && deviceInfos.tipo && deviceInfos.tipo === 'APP') {
					sessionStorage.setItem('deviceInfos', (0, _stringify2.default)(deviceInfos));
				}
			} catch (error) {
				console.error("Ocorreu um erro ao tentar recuperar as informações do dispositivo (ios)", error);
			}
		});
	
		document.addEventListener("message", function (message) {
			try {
				var deviceInfos = JSON.parse(message.data);
				if (deviceInfos.platform === 'android' && deviceInfos.tipo && deviceInfos.tipo === 'APP') {
					sessionStorage.setItem('deviceInfos', (0, _stringify2.default)(deviceInfos));
				}
			} catch (error) {
				console.error("Ocorreu um erro ao tentar recuperar as informações do dispositivo (android)", error);
			}
		});
	
		RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
			var newResponse = {};
	
			if (data && operation === "getList") {
				newResponse = [];
				newResponse.result = data.result;
			} else {
				newResponse = data;
			}
	
			return newResponse;
		});
	}]);
	
	/**
	 * Pre-Loading Service Data
	 */
	services.run(["$http", "$state", "$stateParams", "$rootScope", "labelService", function ($http, $state, $stateParams, $rootScope, labelService) {
		labelService.init();
	
		$rootScope.$on("labelService:labelsChanged", function () {
			$state.transitionTo($state.current, $state.params, {
				reload: true, inherit: false, location: false
			});
		});
	}]);
	
	exports.default = services.name;

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(604);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(606);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _utils = __webpack_require__(474);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Recovery Password Rest Client targeting backend REST API
	 * @ngInject
	 */
	exports.default = function (Restangular) {
		var jwt = null;
		var baseApi = Restangular.all("recovery-password");
	
		var getDeviceInfosHeaders = function getDeviceInfosHeaders() {
			var deviceInfosStr = sessionStorage.getItem('deviceInfos');
			var deviceInfos = JSON.parse(deviceInfosStr);
			return {
				'app-version': deviceInfos.appVersion,
				'device-id': deviceInfos.deviceId,
				'device-model': deviceInfos.deviceModel,
				'device-name': deviceInfos.deviceName,
				'device-brand': deviceInfos.deviceBrand,
				'os-name': deviceInfos.osName,
				'os-version': deviceInfos.osVersion
			};
		};
	
		/**
	  * Encapsulate all requests and extract token in case of success
	  * @param promise
	  */
		var requestInterceptor = function requestInterceptor(promise) {
			return new _promise2.default(function (resolve, reject) {
				promise.then(function (response) {
					jwt = response.headers("jwt-token");
					var headers = (0, _extends3.default)({}, Restangular.defaultHeaders, getDeviceInfosHeaders());
					if (!_utils2.default.isEmpty(jwt)) {
						headers.Authorization = jwt;
					}
					Restangular.setDefaultHeaders(headers);
					resolve(response);
				}, function (err) {
					reject(err);
				});
			});
		};
	
		/**
	  * 1. Init the process of password recovery
	  */
		var initRecoverPasswordProcess = function initRecoverPasswordProcess(personalData) {
			Restangular.setDefaultHeaders((0, _extends3.default)({}, Restangular.defaultHeaders, getDeviceInfosHeaders()));
			return requestInterceptor(baseApi.all("init-password-recovery-process").post(personalData));
		};
	
		/**
	  * 2. Confirm email token
	  */
		var confirmEmailVerificationToken = function confirmEmailVerificationToken(token) {
			return requestInterceptor(baseApi.all("confirm-email-verification-token").post(token));
		};
	
		/**
	  * 3. Send sms token
	  */
		var sendSmsToken = function sendSmsToken() {
			return requestInterceptor(baseApi.all("send-sms-verification-token").post());
		};
	
		var sendNewSmsToken = function sendNewSmsToken(idProcesso) {
			return baseApi.all("send-new-sms-verification-token").post(idProcesso);
		};
	
		var sendNewWhatsAppToken = function sendNewWhatsAppToken(idProcesso) {
			return baseApi.all("send-new-whatsapp-verification-token").post(idProcesso);
		};
	
		/**
	  * 4. Confirm sms token
	  */
		var confirmSmsToken = function confirmSmsToken(token) {
			return requestInterceptor(baseApi.all("confirm-sms-verification-token").post(token));
		};
	
		/**
	 * 5. Retrieve a set o unanswered security questions
	  * @returns promise
	  */
		var retrieveSecurityQuestions = function retrieveSecurityQuestions() {
			var all = baseApi.all("security-questions");
			return requestInterceptor(all.get(""));
		};
	
		/**
	  * 6. Check all answers
	  * @returns promise
	  */
		var checkAnsweredSecurityQuestion = function checkAnsweredSecurityQuestion(securityQuestions) {
			var all = baseApi.all("check-answered-security-question");
			return requestInterceptor(all.post(securityQuestions));
		};
	
		/**
	  * 7. Change Associado's password
	  * @returns promise
	  */
		var changePassword = function changePassword(changePasswordObj) {
			var all = baseApi.all("change-password");
			return requestInterceptor(all.post(changePasswordObj));
		};
	
		/**
	 * 8. Block the chanel's passwords
	 * @returns promise
	 */
		var blockPassword = function blockPassword(blockPasswordObj) {
			return requestInterceptor(baseApi.all("block-password").post(blockPasswordObj));
		};
	
		return {
			initRecoverPasswordProcess: initRecoverPasswordProcess,
			confirmEmailVerificationToken: confirmEmailVerificationToken,
			sendSmsToken: sendSmsToken,
			sendNewSmsToken: sendNewSmsToken,
			sendNewWhatsAppToken: sendNewWhatsAppToken,
			confirmSmsToken: confirmSmsToken,
			retrieveSecurityQuestions: retrieveSecurityQuestions,
			checkAnsweredSecurityQuestion: checkAnsweredSecurityQuestion,
			changePassword: changePassword,
			blockPassword: blockPassword
		};
	};
	exports.default.$inject = ["Restangular"];

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _initialLabels = __webpack_require__(810);
	
	var _initialLabels2 = _interopRequireDefault(_initialLabels);
	
	var _utils = __webpack_require__(474);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _moment = __webpack_require__(629);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Label Service - Resolve labens from Cooperforte WordPress Label Service
	 */
	var labelService = function labelService($rootScope, $http) {
		"ngInject";
	
		//let labels = localStorage.getItem("cachedLabels") ? JSON.parse(localStorage.getItem("cachedLabels")) : initialLabels;
	
		var labels = _initialLabels2.default;
	
		/**
	  * Init Label Service, try to load labels from cache, otherwise go to WordPress Service
	  */
		var init = function init() {
			/*let lastUpdate = localStorage.getItem("lastUpdateLabels") || "2017-11-01";
	  let cooperforteLabelServiceUrl = `http://www.cooperforte.coop.br/mobile-xml-v3?date_filter=${lastUpdate}`;
	  	//Hit WP Label service
	  $http({method: 'GET', url: cooperforteLabelServiceUrl})
	  	.then((res) => {
	  		if (utils.jsonHasPath(res, "data.mobileBankConteudo.senhaOperacional")) {
	  			let newLabels = utils.deepJsonMerge(labels, res.data.mobileBankConteudo.senhaOperacional);
	  				if (JSON.stringify(labels) !== JSON.stringify(newLabels)) {
	  				labels = newLabels;
	  				localStorage.setItem("lastUpdateLabels", moment(new Date()).format("YYYY-MM-DD"));
	  				localStorage.setItem("cachedLabels", JSON.stringify(newLabels));
	  				$rootScope.$emit("labelService:labelsChanged", newLabels);
	  			}
	  		}
	  	});*/
		};
	
		/**
	  * Return labels by given page
	  */
		var getLabelsByPage = function getLabelsByPage(page) {
			return labels ? labels[page] : {};
		};
	
		/**
	  * Return a specific label by page and key
	  */
		var getLabelByPageAndKey = function getLabelByPageAndKey(page, key) {
			return labels ? labels[page] ? labels[page][key] : "" : "";
		};
	
		/**
	  * Return a specific label by pageKey expression
	  * E.G: PageKey expression is a string that's looks like: page:key
	  */
		var getLabelByExpression = function getLabelByExpression(pageKeyExpression) {
			var page = void 0,
			    key = void 0;
	
			if (pageKeyExpression && pageKeyExpression.contains(":")) {
				page = pageKeyExpression.substring(0, pageKeyExpression.indexOf(":"));
				key = pageKeyExpression.substring(pageKeyExpression.indexOf(":") + 1);
			}
	
			return page && key && getLabelByPageAndKey(page, key) ? getLabelByPageAndKey(page, key).titulo : "";
		};
	
		return { getLabelsByPage: getLabelsByPage, getLabelByPageAndKey: getLabelByPageAndKey, getLabelByExpression: getLabelByExpression, init: init };
	};
	labelService.$inject = ["$rootScope", "$http"];
	
	exports.default = labelService;

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//INITIAL LABELS DATA
	exports.default = {
	    global: {
	        systemTitle: { titulo: "RECUPERA\xC7\xC3O DE SENHA / 1\xBA Acesso" },
	
	        titleModal401Error: { titulo: "Tempo de sessão expirado" },
	        textModal401Error: { titulo: "O tempo limite para a conclusão do processo de recuperação de senha se esgotou. Para sua segurança, reinicie o processo." },
	
	        titleModal403Error: { titulo: "Acesso bloqueado" },
	        textModal403Error: { titulo: "Prezado(a) Associado(a), a recuperação automatizada de sua senha de acesso foi bloqueada. Por favor, entre em contato com a Cooperforte. " },
	
	        textModal404InvalidInformation: { titulo: "Infelizmente ocorreu um erro que não nos permitiu prosseguir com o processo de recuperação de senha. Por favor, entre em contato com a COOPERFORTE. " },
	
	        required: { titulo: "Campo obrigatório" },
	
	        titleModal409Error: { titulo: "Senha inválida" },
	
	        nextBtn: { titulo: "Continuar" },
	        nextBtnDesc: { titulo: "Avança para o próximo passo da recuperação da senha" },
	
	        closeBtn: { titulo: "Fechar" },
	        closeBtnDesc: { titulo: "Fecha essa janela e retorna ao passo anterior" },
	
	        continueProcessBtn: { titulo: "Continuar" },
	        continueProcessBtnDesc: { titulo: "Fecha essa janela e avança para o próximo passo da recuperação da senha" },
	        validarCodigoBtn: { titulo: "Validar o código" },
	
	        labelSupportCentral: { titulo: "Central de Atendimento:" },
	        centralTelephoneNumber: { titulo: "4007-2762 (Capital e regiões metropolitanas)" },
	        centralTelephoneNumber2: { titulo: "0800 701 3766 (Demais localidades)" }
	    },
	
	    login: {
	        welcomeText1: { titulo: "Olá, esqueceu sua senha?" },
	        welcomeText2: { titulo: "Não se preocupe, vamos recuperá-la!" },
	        welcomeText3: { titulo: "Para cadastrar ou recuperar sua senha, preencha seu CPF e Data de Nascimento, clique em não sou robô e depois em continuar." },
	
	        cpfField: { titulo: "Informe seu CPF" },
	        birthdayField: { titulo: "Informe sua Data de Nascimento" },
	
	        captchaInfo: { titulo: "Responda à pergunta de segurança acima" },
	        invalidCpf: { titulo: "CPF Inválido" },
	        invalidBirthday: { titulo: "Data de nascimento inválida" },
	        titleModalRPStarted: { titulo: "Recuperação de senha / 1º acesso" },
	        text1ModalRPStarted: { titulo: "Você solicitou uma nova senha de acesso aos canais digitais da COOPERFORTE. Para confirmar, um código de segurança será enviado ao seu e-mail e por SMS ao seu celular, conforme cadastro junto à cooperativa:" },
	        text1ModalRPStartedCelular: { titulo: "Para confirmar a autenticidade deste acesso, ser\xE1 necess\xE1ria uma segunda valida\xE7\xE3o, onde um c\xF3digo de seguran\xE7a foi enviado ao seu Celular (SMS) cadastrado na COOPERFORTE." },
	        text1ModalRPStartedEmail: { titulo: "Para confirmar a autenticidade deste acesso, um c\xF3digo de seguran\xE7a foi enviado ao seu E-mail cadastrado na COOPERFORTE." },
	        text2ModalRPStarted: { titulo: "Será necessário a confirmação desse código para prosseguir com o processo de recuperação da senha." },
	
	        titleModal403Error: { titulo: "Não foi possível prosseguir com sua solicitação!" },
	
	        titleModal404Error: { titulo: "Dados inválidos" },
	        textModal404Error: { titulo: "Os dados informados são inválidos. Verifique-os e tente novamente." },
	
	        titleModal400Error: { titulo: "Processo de recuperação de senha de acesso" },
	        textModal400Error: { titulo: "Desculpe, mas não encontramos seus dados de contato. Por favor, entre em contato com a nossa Central de Atendimento." },
	
	        titleModal401Error: { titulo: "Acesso bloqueado" },
	        textModal401Error: { titulo: "Prezado(a) Associado(a), a recuperação automatizada de sua senha de acesso foi bloqueada. Por favor, entre em contato com a Cooperforte. " },
	
	        semEmailECelular1: { titulo: "Para recuperação da SENHA DE ACESSO, entre em contato com nossa Central de Atendimento pelos números: " },
	        titleModal406Error: { titulo: "Associação em análise" },
	        textModal406rror1: { titulo: "Seu pedido de associação foi finalizado e já está sendo analisado!" },
	        textModal406rror2: { titulo: "Fique tranquilo, nós vamos te avisar quando a análise for concluída." },
	        textModal406rror3: { titulo: "Ative as notificações do APP COOPERFORTE no seu telefone celular para receber nossas comunicações." }
	    },
	
	    tokenEmail: {
	        welcomeText: { titulo: "Digite abaixo o código de segurança que você recebeu em seu E-mail:" },
	        confirmationToken: { titulo: "Código de Segurança" },
	        footerText1: { titulo: "Dúvidas? Entre em contato com a nossa Central de Atendimento no" },
	        footerText2: { titulo: "4007-2762 (Capital e regiões metropolitanas) ou 0800 701 3766 (Demais localidades)." },
	        incompleteCode: { titulo: "Código incompleto" },
	
	        titleModalTokenValid: { titulo: "Código de Segurança" },
	        textModalTokenValid: { titulo: "Código de Segurança validado com sucesso." },
	
	        titleModal400Error: { titulo: "Código de Segurança" },
	        textModal400Error: { titulo: "Código Incorreto. Verifique-o e tente novamente." },
	
	        validateBtn: { titulo: "Validar" },
	        validateBtnDesc: { titulo: "Valida o código de segurança informado" }
	    },
	
	    tokenSms: {
	        welcomeText: { titulo: "Digite abaixo o código de segurança que você recebeu em seu Celular (SMS):" },
	        confirmationToken: { titulo: "Código de Segurança" },
	        footerText1: { titulo: "Dúvidas? Entre em contato com a nossa Central de Atendimento no" },
	        footerText2: { titulo: "4007-2762 (Capital e regiões metropolitanas) ou 0800 701 3766 (Demais localidades)." },
	        incompleteCode: { titulo: "Código incompleto" },
	        text1ModalRPStartedSms: { titulo: "Para confirmar a autenticidade deste acesso, um c\xF3digo de seguran\xE7a foi enviado ao seu Celular SMS) cadastrado na COOPERFORTE." },
	        titleModalTokenValid: { titulo: "Código de Segurança" },
	        textModalTokenValid: { titulo: "Código de Segurança validado com sucesso." },
	        titleModal400Error: { titulo: "Código de Segurança" },
	        textModal400Error: { titulo: "Código Incorreto. Verifique-o e tente novamente." },
	        generateNewCode: { titulo: "Enviar novo código (SMS ou WhatsAPP)" },
	        optionsGenerateNewCode: { titulo: "Escolha como prefere enviar o novo código:" },
	        validateBtn: { titulo: "Validar" },
	        validateBtnDesc: { titulo: "Valida o código de segurança informado" }
	    },
	    newTokenWhatsApp: {
	        welcomeText: { titulo: "Digite abaixo o código de segurança que você recebeu em seu Celular (WhatsApp):" },
	        textModalNewToken: { titulo: "Novo código enviado por WhatsApp" },
	        newCodeBtnWhatsApp: { titulo: "Quero receber novo código por WhatsApp" }
	    },
	
	    newTokenSms: {
	        titleModalNewToken: { titulo: "Solicitação de novo código" },
	        newCodeBtnSms: { titulo: "Quero receber novo código por SMS" },
	        textModalNewToken: { titulo: "Novo código enviado por SMS" },
	        textBtn: { titulo: "Ciente" },
	        titleErrorModal: { titulo: "Falha nossa!" },
	        textErrorModal: { titulo: "Ocorreu um erro inesperado!" }
	    },
	
	    question: {
	        footerText1: { titulo: "Dificuldades em responder as perguntas?" },
	        footerText2: { titulo: "Favor entrar em contato com nossa Central de Atendimento" },
	        welcomeText: { titulo: "Responda a pergunta abaixo" },
	        errorNoAnswer: { titulo: "\xC9 obrigat\xF3rio responder a pergunta!" },
	        sendBtn: { titulo: "Continuar" },
	        sendBtnDesc: { titulo: "Responda a questão" }
	    },
	
	    password: {
	        titleModalSenha: { titulo: "Senha de acesso cadastrada com sucesso!" },
	        welcomeText3: { titulo: "Cadastramento de senha de acesso aos canais digitais" },
	        newPasswordField: { titulo: "Digite sua senha de acesso de 8 a 20 caracteres" },
	        repeatPasswordField: { titulo: "Confirme sua senha de acesso de 8 a 20 caracteres:" },
	        invalidPassword: { titulo: "A senha deve conter pelo menos 8 caracteres." },
	        matchError: { titulo: "Senha n\xE3o confere com a informada." },
	        footerText1: { titulo: "Dificuldades em alterar a senha?" },
	        footerText2: { titulo: "Favor entrar em contato com nossa Central de Atendimento" },
	        footerText3: { titulo: "Para sua segurança, evite usar combinações previsíveis como sua data de nascimento, número de identidade, CPF ou telefone." },
	        welcomeText: { titulo: "Responda a duas perguntas de seguran\xE7a" },
	        errorNoAnswer: { titulo: "\xC9 obrigat\xF3rio responder a pergunta!" },
	        changeBtn: { titulo: "Cadastrar/Alterar" },
	        changeBtnDesc: { titulo: "Altera sua senha nos canais COOPERFORTE" },
	        passwordChangedText: { titulo: "Atenção! Esta senha é de uso pessoal e exclusivo para acessar os canais digitais da COOPERFORTE." },
	        passwordChangedText2: { titulo: "Memorize e guarde sua senha em local seguro e nunca compartilhe com terceiros." },
	        passwordLength: { titulo: "Sua senha de acesso deve conter a seguinte combinação:" },
	        haveOneNumber: { titulo: "N\xFAmero" },
	        haveUppercaseCaracter: { titulo: "Letra mai\xFAscula" },
	        haveLowercaseCaracter: { titulo: "Letra min\xFAscula" },
	        haveSpecialCaracter: { titulo: "Pelo menos 1 caractere especial (!@#$%&)" },
	        passwordsMatch: { titulo: "Senha e Confirma\xE7\xE3o id\xEAnticas" },
	        passwordHaveMinimumEightCaracters: { titulo: "8 a 20 caracteres" },
	        titleModal400Error: { titulo: "As senhas informadas s\xE3o inv\xE1lidas, corrija e tente novamente." },
	        titleModal409InvalidPassword: { titulo: "Aten\xE7\xE3o! A sua nova senha n\xE3o pode ser igual a anterior." },
	        passwordChangedBtnDesc: { titulo: 'Fecha a modal' },
	        passwordChangedBtn: { titulo: 'Fechar' },
	        passwordChangedTitle: { titulo: 'Sucesso' }
	    },
	
	    success: {
	        welcomeText3: { titulo: "Senha de acesso cadastrada com sucesso!" },
	        mainText: { titulo: "Atenção! Esta senha é de uso pessoal e exclusivo para acessar os canais digitais da COOPERFORTE." },
	        mainText2: { titulo: "Memorize e guarde sua senha em local seguro e nunca compartilhe com terceiros." },
	        navigateToBtn: { titulo: 'Acessar' },
	        navigateToBtnDesc: { titulo: 'Acesse sua conta no Site Cooperforte' },
	        footerText1: { titulo: "Ainda ficou alguma d\xFAvida?" },
	        footerText2: { titulo: "Favor entrar em contato com nossa Central de Atendimento" }
	    }
	
	};

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _autofocus = __webpack_require__(812);
	
	var _autofocus2 = _interopRequireDefault(_autofocus);
	
	var _noFutureDates = __webpack_require__(813);
	
	var _noFutureDates2 = _interopRequireDefault(_noFutureDates);
	
	var _passwordMatch = __webpack_require__(814);
	
	var _passwordMatch2 = _interopRequireDefault(_passwordMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Module definition for directives
	 */
	var directives = _angular2.default.module('app.directives', []);
	
	directives.directive('exAutofocus', _autofocus2.default);
	directives.directive('noFutureDates', _noFutureDates2.default);
	directives.directive('passwordMatch', _passwordMatch2.default);
	
	exports.default = directives.name;

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
	 * templates and such with AngularJS. Use this simple directive to
	 * tame this beast once and for all.
	 *
	 * Usage:
	 * <input type="text" autofocus>
	 *
	 * @ngInject
	 */
	exports.default = function ($timeout) {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $timeout(function () {
	        $element[0].focus();
	      });
	    }
	  };
	};
	exports.default.$inject = ["$timeout"];

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _moment = __webpack_require__(629);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Directive for blocking future dates
	 *
	 * @ngInject
	 */
	exports.default = function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function link($scope, $element, $attributes, ngModel) {
				ngModel.$parsers.unshift(function (value) {
					var defaultMask = "DD/MM/YYYY";
	
					if (!$attributes.noFutureDates) console.warn("no-future-dates directive: Missing moment.js date mask. Using default: DD/MM/YYYY");
	
					var today = new Date();
					var birthday = (0, _moment2.default)(value, $attributes.noFutureDates || defaultMask).toDate();
	
					var isFuture = birthday.getTime() > today.getTime();
	
					if (isFuture) {
						ngModel.$setValidity('isFutureDate', false);
						return undefined;
					} else {
						ngModel.$setValidity('isFutureDate', true);
						return birthday;
					}
				});
			}
		};
	};

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Directive for match two password fields
	 *
	 * @ngInject
	 */
	exports.default = function () {
	    return {
	        require: 'ngModel',
	        link: function link(scope, elem, attrs, ctrl) {
	            var firstPassword = '#' + attrs.passwordMatch;
	            elem.add(firstPassword).on('keyup', function () {
	                scope.$apply(function () {
	                    var repeat = $(firstPassword);
	                    var v = elem.val() === repeat.val();
	                    ctrl.$setValidity('passwordMatch', v);
	                });
	            });
	        }
	    };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(335)))

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(816);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(421)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.style.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(420)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;width:100%;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#e9eaeb}.linhaBottom{border-bottom:1px solid #ccc}app{height:100%;width:100%}.welcome-texts{text-align:justify}.white{color:#000;background-color:#fff}.espacamento{line-height:2em}.btn-cooperforte{color:#000;-webkit-text-shadow:0 -1px 0 rgba(0,0,0,.25);text-shadow:0 -1px 0 rgba(0,0,0,.25);background-color:#fdcf00}.panel-body{font-size:1em}@media only screen and (max-width:767px){.panel-default{margin-top:5px}body{background-color:#fff}.panel{border:0 solid #fff}}.panel-body{padding:25px!important;border-radius:20px}.btn-valida{width:100%;background-color:#fff;padding:12px 0;font-weight:bolder;border:1px solid #ccc;margin-bottom:10px}@media only screen and (min-width:768px){.panel-default{margin-top:10vh}}.panel-default>.panel-heading{background-color:transparent;border-color:transparent}.form-group{margin-bottom:40px}@media (max-width:767px){.panel-default{margin-top:10px}body{height:100%;width:100%;background-color:#fff}.panel-default{margin-top:5vh}}.m-0{margin:0!important}.mX-0{margin-left:0!important;margin-right:0!important}.mY-0{margin-top:0!important;margin-bottom:0!important}.p-0{padding:0!important}.pX-0{padding-left:0!important;padding-right:0!important}.pY-0{padding-top:0!important;padding-bottom:0!important}.mt-0{margin-top:0!important}.pt-0{padding-top:0!important}.mb-0{margin-bottom:0!important}.pb-0{padding-bottom:0!important}.ml-0{margin-left:0!important}.pl-0{padding-left:0!important}.mr-0{margin-right:0!important}.pr-0{padding-right:0!important}.m-5{margin:5px!important}.mX-5{margin-left:5px!important;margin-right:5px!important}.mY-5{margin-top:5px!important;margin-bottom:5px!important}.p-5{padding:5px!important}.pX-5{padding-left:5px!important;padding-right:5px!important}.pY-5{padding-top:5px!important;padding-bottom:5px!important}.mt-5{margin-top:5px!important}.pt-5{padding-top:5px!important}.mb-5{margin-bottom:5px!important}.pb-5{padding-bottom:5px!important}.ml-5{margin-left:5px!important}.pl-5{padding-left:5px!important}.mr-5{margin-right:5px!important}.pr-5{padding-right:5px!important}.m-10{margin:10px!important}.mX-10{margin-left:10px!important;margin-right:10px!important}.mY-10{margin-top:10px!important;margin-bottom:10px!important}.p-10{padding:10px!important}.pX-10{padding-left:10px!important;padding-right:10px!important}.pY-10{padding-top:10px!important;padding-bottom:10px!important}.mt-10{margin-top:10px!important}.pt-10{padding-top:10px!important}.mb-10{margin-bottom:10px!important}.pb-10{padding-bottom:10px!important}.ml-10{margin-left:10px!important}.pl-10{padding-left:10px!important}.mr-10{margin-right:10px!important}.pr-10{padding-right:10px!important}.m-15{margin:15px!important}.mX-15{margin-left:15px!important;margin-right:15px!important}.mY-15{margin-top:15px!important;margin-bottom:15px!important}.p-15{padding:15px!important}.pX-15{padding-left:15px!important;padding-right:15px!important}.pY-15{padding-top:15px!important;padding-bottom:15px!important}.mt-15{margin-top:15px!important}.pt-15{padding-top:15px!important}.mb-15{margin-bottom:15px!important}.pb-15{padding-bottom:15px!important}.ml-15{margin-left:15px!important}.pl-15{padding-left:15px!important}.mr-15{margin-right:15px!important}.pr-15{padding-right:15px!important}.m-20{margin:20px!important}.mX-20{margin-left:20px!important;margin-right:20px!important}.mY-20{margin-top:20px!important;margin-bottom:20px!important}.p-20{padding:20px!important}.pX-20{padding-left:20px!important;padding-right:20px!important}.pY-20{padding-top:20px!important;padding-bottom:20px!important}.mt-20{margin-top:20px!important}.pt-20{padding-top:20px!important}.mb-20{margin-bottom:20px!important}.pb-20{padding-bottom:20px!important}.ml-20{margin-left:20px!important}.pl-20{padding-left:20px!important}.mr-20{margin-right:20px!important}.pr-20{padding-right:20px!important}.m-25{margin:25px!important}.mX-25{margin-left:25px!important;margin-right:25px!important}.mY-25{margin-top:25px!important;margin-bottom:25px!important}.p-25{padding:25px!important}.pX-25{padding-left:25px!important;padding-right:25px!important}.pY-25{padding-top:25px!important;padding-bottom:25px!important}.mt-25{margin-top:25px!important}.pt-25{padding-top:25px!important}.mb-25{margin-bottom:25px!important}.pb-25{padding-bottom:25px!important}.ml-25{margin-left:25px!important}.pl-25{padding-left:25px!important}.mr-25{margin-right:25px!important}.pr-25{padding-right:25px!important}.m-30{margin:30px!important}.mX-30{margin-left:30px!important;margin-right:30px!important}.mY-30{margin-top:30px!important;margin-bottom:30px!important}.p-30{padding:30px!important}.pX-30{padding-left:30px!important;padding-right:30px!important}.pY-30{padding-top:30px!important;padding-bottom:30px!important}.mt-30{margin-top:30px!important}.pt-30{padding-top:30px!important}.mb-30{margin-bottom:30px!important}.pb-30{padding-bottom:30px!important}.ml-30{margin-left:30px!important}.pl-30{padding-left:30px!important}.mr-30{margin-right:30px!important}.pr-30{padding-right:30px!important}.m-35{margin:35px!important}.mX-35{margin-left:35px!important;margin-right:35px!important}.mY-35{margin-top:35px!important;margin-bottom:35px!important}.p-35{padding:35px!important}.pX-35{padding-left:35px!important;padding-right:35px!important}.pY-35{padding-top:35px!important;padding-bottom:35px!important}.mt-35{margin-top:35px!important}.pt-35{padding-top:35px!important}.mb-35{margin-bottom:35px!important}.pb-35{padding-bottom:35px!important}.ml-35{margin-left:35px!important}.pl-35{padding-left:35px!important}.mr-35{margin-right:35px!important}.pr-35{padding-right:35px!important}.m-40{margin:40px!important}.mX-40{margin-left:40px!important;margin-right:40px!important}.mY-40{margin-top:40px!important;margin-bottom:40px!important}.p-40{padding:40px!important}.pX-40{padding-left:40px!important;padding-right:40px!important}.pY-40{padding-top:40px!important;padding-bottom:40px!important}.mt-40{margin-top:40px!important}.pt-40{padding-top:40px!important}.mb-40{margin-bottom:40px!important}.pb-40{padding-bottom:40px!important}.ml-40{margin-left:40px!important}.pl-40{padding-left:40px!important}.mr-40{margin-right:40px!important}.pr-40{padding-right:40px!important}.m-45{margin:45px!important}.mX-45{margin-left:45px!important;margin-right:45px!important}.mY-45{margin-top:45px!important;margin-bottom:45px!important}.p-45{padding:45px!important}.pX-45{padding-left:45px!important;padding-right:45px!important}.pY-45{padding-top:45px!important;padding-bottom:45px!important}.mt-45{margin-top:45px!important}.pt-45{padding-top:45px!important}.mb-45{margin-bottom:45px!important}.pb-45{padding-bottom:45px!important}.ml-45{margin-left:45px!important}.pl-45{padding-left:45px!important}.mr-45{margin-right:45px!important}.pr-45{padding-right:45px!important}.m-50{margin:50px!important}.mX-50{margin-left:50px!important;margin-right:50px!important}.mY-50{margin-top:50px!important;margin-bottom:50px!important}.p-50{padding:50px!important}.pX-50{padding-left:50px!important;padding-right:50px!important}.pY-50{padding-top:50px!important;padding-bottom:50px!important}.mt-50{margin-top:50px!important}.pt-50{padding-top:50px!important}.mb-50{margin-bottom:50px!important}.pb-50{padding-bottom:50px!important}.ml-50{margin-left:50px!important}.pl-50{padding-left:50px!important}.mr-50{margin-right:50px!important}.pr-50{padding-right:50px!important}.m-75{margin:75px!important}.mX-75{margin-left:75px!important;margin-right:75px!important}.mY-75{margin-top:75px!important;margin-bottom:75px!important}.p-75{padding:75px!important}.pX-75{padding-left:75px!important;padding-right:75px!important}.pY-75{padding-top:75px!important;padding-bottom:75px!important}.mt-75{margin-top:75px!important}.pt-75{padding-top:75px!important}.mb-75{margin-bottom:75px!important}.pb-75{padding-bottom:75px!important}.ml-75{margin-left:75px!important}.pl-75{padding-left:75px!important}.mr-75{margin-right:75px!important}.pr-75{padding-right:75px!important}.m-100{margin:100px!important}.mX-100{margin-left:100px!important;margin-right:100px!important}.mY-100{margin-top:100px!important;margin-bottom:100px!important}.p-100{padding:100px!important}.pX-100{padding-left:100px!important;padding-right:100px!important}.pY-100{padding-top:100px!important;padding-bottom:100px!important}.mt-100{margin-top:100px!important}.pt-100{padding-top:100px!important}.mb-100{margin-bottom:100px!important}.pb-100{padding-bottom:100px!important}.ml-100{margin-left:100px!important}.pl-100{padding-left:100px!important}.mr-100{margin-right:100px!important}.pr-100{padding-right:100px!important}.modal-dialog{padding-top:50px!important}.float-left{float:left}.round{background-color:#222;color:#fff}.round,.round.hollow{display:inline-block;height:30px;width:30px;line-height:30px;border-radius:15px;text-align:center}.round.hollow{background-color:#fff;color:#222;box-shadow:0 0 0 3px rgba(0,0,0,.75)}.round.round-sm{height:20px;width:20px;line-height:20px;border-radius:10px;font-size:.7em}.round.round-lg{height:40px;width:40px;line-height:40px;border-radius:20px;font-size:1.5em}.round.cooperforte{background-color:#fdcf00}.round.hollow.cooperforte{color:#fdcf00;background-color:#fff;box-shadow:0 0 0 3px #fdcf00}", ""]);
	
	// exports


/***/ }),

/***/ 817:
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default app\">\n    <div class=\"panel-heading text-center p-0 pt-5\">\n        <a href=\"http://www.cooperforte.coop.br/\" title=\"Cooperforte\">\n            <img class=\"pt-10\" src=\"{{$ctrl.logo}}\" title=\"Cooperforte\"/>\n        </a>\n        <div class=\"linhaBottom\">\n            <h5 class=\"pt-5 text-uppercase\"><strong>{{$ctrl.systemTitle}}</strong></strong></h5>\n        </div>\n    </div>\n    <ui-view></ui-view>\n    <div class=\"text-center\">versão 1.2.25</div>\n</div>\n\n\n\n\n\n"

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(523);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _logo = __webpack_require__(819);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Main App Component Controller
	 * @ngInject
	 */
	var AppController = function AppController(labelService, $rootScope, $scope, $location, $timeout) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AppController);
	
	    this.logo = _logo2.default;
	
	    this.systemTitle = labelService.getLabelByPageAndKey("global", "systemTitle").titulo;
	    $rootScope.$on("labelService:labelsChanged", function () {
	        _this.systemTitle = labelService.getLabelByPageAndKey("global", "systemTitle").titulo;
	    });
	
	    $rootScope.$on('$locationChangeSuccess', function () {
	
	        $rootScope.$watch(function () {
	            return $location.path();
	        }, function (newLocation, oldLocation) {
	            $timeout(function () {
	                $('.container').animate({ scrollTop: 0 }, 400);
	            }, 50);
	
	            if (newLocation === '/pergunta-seguranca' && oldLocation === '/alterar-senha') {
	                history.pushState({}, '', 'senhaop/#/alterar-senha');
	            }
	            if (newLocation === '/alterar-senha' && oldLocation === '/senha-alterada') {
	                history.pushState({}, '', 'senhaop/#/senha-alterada');
	            }
	        });
	    });
	};
	AppController.$inject = ["labelService", "$rootScope", "$scope", "$location", "$timeout"];
	
	exports.default = AppController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(335)))

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "imgs/logo.png";

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "imgs/faviconCooper.ico";

/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js